import React, { useEffect } from 'react';
import * as Forms from '../slices/formsSlice';
import * as Quotes from '../slices/quotesSlice';
import * as User from '../slices/userSlice';
import * as UI from '../slices/uiSlice';
import { handleStaffEmailChange } from '../slices/consultants';
import { AnyAction } from '@reduxjs/toolkit';
import QuoteSummary from './quotesummary';
import { useAppDispatch, useAppSelector } from '../slices/index';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMagnifyingGlassLocation } from '@fortawesome/free-solid-svg-icons';
import { faSync } from '@fortawesome/free-solid-svg-icons';
import { handleScroll, filterSchemesByDeveloper, filterSitesByDeveloper, filterDevelopersBySiteOrScheme, doFormOnChange, getFormValueWithId, getFormValidWithId, getFormMessageWithId, getAddressListWithId, getPostcodeAddresses, selectAddress, getUkDate, saveQuote, acceptQuote, emailQuote, validateForm, getJSONWithFormValues, applyBackendValidationErrors } from '../utilities';
import icon_tick from '../assets/Tick_Circle.svg';
import icon_save from '../assets/Save_icon.svg';
import icon_generate from '../assets/Generate_icon.svg';
import icon_email from '../assets/Email_White.svg';
import icon_thumb from '../assets/Instruct_Thumb_icon.svg';

const QuoteRemortgage = () => {
	const dispatch = useAppDispatch();
	const quotes = useAppSelector(state => state.quotes);
	const forms = useAppSelector(state => state.forms);
	const user = useAppSelector(state => state.user);
	const introducer = useAppSelector(state => state.user.introducer);
	const qfid = "QF" + quotes.quote.quoteid;
	const ifid = "IF" + quotes.quote.quoteid;

	const isGenerated = !(getUkDate(quotes.quote.generated) === '');
	const isAccepted = !(getUkDate(quotes.quote.accepted) === '');
	const isInstructed = !(getUkDate(quotes.quote.instructed) === '');
	const isBusy = quotes.quote.isSaving || quotes.quote.isGenerating || quotes.quote.isEmailing;

	const filteredSchemes = filterSchemesByDeveloper(qfid);
	const filteredSites = filterSitesByDeveloper(qfid);
	const filteredDevelopers = filterDevelopersBySiteOrScheme(qfid);

	const generateQuote = (el: string, id: string) => {
		if (quotes.quote.isGenerating || quotes.quote.isSaving || quotes.quote.isEmailing) {
			dispatch(UI.setInfo({ visible: true, message: 'Please wait for the quote to finish saving before generating.' }));
			return;
		}
		if (!validateForm(el, id)) { return; }
		if (!quotes.quote.quoteid) {
			dispatch(UI.setInfo({ visible: true, message: 'Please Save the Quote before Generating.' }));
			return;
		}
		
		saveQuote().then((saved) => {
			if (!saved) { return; }
			dispatch(Quotes.setGenerating(true));
			const json = getJSONWithFormValues(id);
			dispatch(Quotes.setQuoteFormData(json) as unknown as AnyAction);
			dispatch(Quotes.generateRemortgageQuote({ id: quotes.quote.quoteid, json: json }) as unknown as AnyAction).then(() => {
				dispatch(Quotes.setOffset('-100%'));
				emailQuote();
			});
		});
	}

	const onStaffSelect = (event: React.ChangeEvent<HTMLSelectElement>) => {
		const emailInput = document.getElementById(`staff_email_Leadersromansgroup`) as HTMLInputElement;
		if (emailInput) {
			emailInput.value = handleStaffEmailChange(event.target.value, 'Leadersromansgroup');
		}
	};

	const instructQuote = (el: string, id: string) => {
		if (!quotes.quote.isInstructing) {
			if (validateForm(el, id)) {
				dispatch(Quotes.setInstructing(true));
				const json = getJSONWithFormValues(ifid);
				const state: Quotes.instructQuoteState = {
					id: quotes.quote.quoteid,
					quoteformdata: quotes.quote.quoteformdata,
					quotebreakdowndata: quotes.quote.quotebreakdowndata,
					instructionformdata: json
				}
				dispatch(Quotes.setInstructionFormData(json) as unknown as AnyAction);
				dispatch(Quotes.instructRemortgageQuote(state) as unknown as AnyAction).then((result: any) => {
					const v = applyBackendValidationErrors(result.payload as string, [ifid]);
					if (v.handled) {
						dispatch(UI.setError({ visible: true, message: v.message }));
						return;
					}
					dispatch(UI.setInfo({ visible: true, message: 'Thank you for your instruction. The file will be opened within the next 4 working hours. We will send to the client their PLS 247 app log in details shortly. Within our app, they can complete their initial paperwork, track the progress of their file and message the team.' }));
				});
			}
		}
	}

	useEffect(() => {
		if (filteredSchemes.length == 1) {
			dispatch(Forms.setFormValueWithId({ form: qfid, type: 'select-one', id: "quote_scheme_id", val: filteredSchemes[0].schemeid }));
		}
	}, [filteredSchemes.length, filteredSchemes[0]]);

	useEffect(() => {
		if (filteredDevelopers.length == 1) {
			dispatch(Forms.setFormValueWithId({ form: qfid, type: 'select-one', id: "quote_developer_id", val: filteredDevelopers[0].developerid }));
		}
	}, [filteredDevelopers.length, filteredDevelopers[0]]);

	useEffect(() => {
		dispatch(Forms.setFormValueWithId({ form: qfid, type: 'select-one', id: "quote_introducer_id", val: introducer.introducerid }));
		dispatch(Forms.setFormValueWithId({ form: qfid, type: 'select-one', id: "quote_customer_source", val: 'Developer' }));
		dispatch(Quotes.setOffset('0%'));

		if (isGenerated) {
			dispatch(Quotes.setOffset('-100%'));
		}
		if (isAccepted) {
			dispatch(Quotes.setOffset('-200%'));
		}
	}, []);

	return (
		<div style={{ color: 'black' }}>
			<div style={{ display: 'flex' }}>
				<div style={{ display: 'flex', width: '60%' }}>
					<div className='buttonPurple' style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', overflow: 'hidden', flex: '1 1 0px' }} onClick={() => dispatch(Quotes.setOffset('0%'))}>
						<div style={{ width: 28, height: 24 }}></div>
						<div style={{ whiteSpace: 'nowrap', textOverflow: 'ellipsis', overflow: 'hidden' }}>Remortgage Quote Form</div>
						<div style={{ width: 28, height: 24 }}>
							{isGenerated &&
								<img style={{ width: 24, height: 24, marginRight: 8 }} src={icon_tick} alt='Tick-Icon' />
							}
						</div>
					</div>
					<div className={(isGenerated ? 'buttonPurple' : 'buttonGrey')} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', overflow: 'hidden', flex: '1 1 0px' }} onClick={(isGenerated ? () => dispatch(Quotes.setOffset('-100%')) : () => { })}>
						<div style={{ width: 28, height: 24 }}></div>
						<div style={{ whiteSpace: 'nowrap', textOverflow: 'ellipsis', overflow: 'hidden' }}>Remortgage Quote Summary</div>
						<div style={{ width: 28, height: 24 }}>
							{isAccepted &&
								<img style={{ width: 24, height: 24, marginRight: 8 }} src={icon_tick} alt='Tick-Icon' />
							}
						</div>
					</div>
					<div className={(isAccepted ? 'buttonPurple' : 'buttonGrey')} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', overflow: 'hidden', flex: '1 1 0px' }} onClick={(isAccepted ? () => dispatch(Quotes.setOffset('-200%')) : () => { })}>
						<div style={{ width: 28, height: 24 }}></div>
						<div style={{ whiteSpace: 'nowrap', textOverflow: 'ellipsis', overflow: 'hidden' }}>Remortgage Instruction Form</div>
						<div style={{ width: 28, height: 24 }}>
							{isInstructed &&
								<img style={{ width: 24, height: 24, marginRight: 8 }} src={icon_tick} alt='Tick-Icon' />
							}
						</div>
					</div>
				</div>
				{quotes.offset === '0%' &&
					<div style={{ display: 'flex', width: '40%' }}>
						<div className='buttonGreen' style={{ borderRadius: 24, display: 'flex', justifyContent: 'space-between', alignItems: 'center', overflow: 'hidden', flex: '1 1 0px' }} onClick={() => saveQuote()}>
							<div style={{ width: 28, height: 24 }}>
								<img style={{ width: 24, height: 24, marginRight: 8 }} src={icon_save} alt='Save-Icon' />
							</div>
							<div style={{ whiteSpace: 'nowrap', textOverflow: 'ellipsis', overflow: 'hidden' }}>Save Quote</div>
							<div style={{ width: 28, height: 24 }}>
								{quotes.quote.isSaving &&
									<FontAwesomeIcon className='fa-spin' style={{ fontSize: 22, marginRight: 8 }} icon={faSync} />
								}
							</div>
						</div>
						<div className={isBusy ? 'buttonGrey' : 'buttonGreen'} style={{ borderRadius: 24, display: 'flex', justifyContent: 'space-between', alignItems: 'center', overflow: 'hidden', flex: '1 1 0px' }} onClick={() => generateQuote("QF", qfid)}>
							<div style={{ width: 28, height: 24 }}>
								<img style={{ width: 24, height: 24, marginRight: 8 }} src={icon_generate} alt='Generate-Icon' />
							</div>
							<div style={{ whiteSpace: 'nowrap', textOverflow: 'ellipsis', overflow: 'hidden' }}>Generate Quote</div>
							<div style={{ width: 28, height: 24 }}>
								{quotes.quote.isGenerating &&
									<FontAwesomeIcon className='fa-spin' style={{ fontSize: 22, marginRight: 8 }} icon={faSync} />
								}
							</div>
						</div>
					</div>
				}
				{quotes.offset === '-100%' &&
					<div style={{ display: 'flex', width: '40%' }}>
						<div className='buttonGreen' style={{ borderRadius: 24, display: 'flex', justifyContent: 'space-between', alignItems: 'center', overflow: 'hidden', flex: '1 1 0px' }} onClick={() => saveQuote()}>
							<div style={{ width: 28, height: 24 }}>
								<img style={{ width: 24, height: 24, marginRight: 8 }} src={icon_save} alt='Save-Icon' />
							</div>
							<div style={{ whiteSpace: 'nowrap', textOverflow: 'ellipsis', overflow: 'hidden' }}>Save Quote</div>
							<div style={{ width: 28, height: 24 }}>
								{quotes.quote.isSaving &&
									<FontAwesomeIcon className='fa-spin' style={{ fontSize: 22, marginRight: 8 }} icon={faSync} />
								}
							</div>
						</div>
						<div className='buttonGreen' style={{ borderRadius: 24, display: 'flex', justifyContent: 'space-between', alignItems: 'center', overflow: 'hidden', flex: '1 1 0px' }} onClick={() => emailQuote()}>
							<div style={{ width: 28, height: 24 }}>
								<img style={{ width: 24, height: 24, marginRight: 8 }} src={icon_email} alt='Email-Icon' />
							</div>
							<div style={{ whiteSpace: 'nowrap', textOverflow: 'ellipsis', overflow: 'hidden' }}>Email Quote</div>
							<div style={{ width: 28, height: 24 }}>
								{quotes.quote.isEmailing &&
									<FontAwesomeIcon className='fa-spin' style={{ fontSize: 22, marginRight: 8 }} icon={faSync} />
								}
							</div>
						</div>
						<div className='buttonGreen' style={{ borderRadius: 24, display: 'flex', justifyContent: 'space-between', alignItems: 'center', overflow: 'hidden', flex: '1 1 0px' }} onClick={() => acceptQuote()}>
							<div style={{ width: 28, height: 24 }}></div>
							<div style={{ whiteSpace: 'nowrap', textOverflow: 'ellipsis', overflow: 'hidden' }}>Accept Quote</div>
							<div style={{ width: 28, height: 24 }}>
								{quotes.quote.isAccepting &&
									<FontAwesomeIcon className='fa-spin' style={{ fontSize: 22, marginRight: 8 }} icon={faSync} />
								}
							</div>
						</div>
					</div>
				}
				{quotes.offset === '-200%' &&
					<div style={{ display: 'flex', width: '40%' }}>
						<div className='buttonGreen' style={{ borderRadius: 24, display: 'flex', justifyContent: 'space-between', alignItems: 'center', overflow: 'hidden', flex: '1 1 0px' }} onClick={() => saveQuote()}>
							<div style={{ width: 28, height: 24 }}>
								<img style={{ width: 24, height: 24, marginRight: 8 }} src={icon_save} alt='Save-Icon' />
							</div>
							<div style={{ whiteSpace: 'nowrap', textOverflow: 'ellipsis', overflow: 'hidden' }}>Save Quote</div>
							<div style={{ width: 28, height: 24 }}>
								{quotes.quote.isSaving &&
									<FontAwesomeIcon className='fa-spin' style={{ fontSize: 22, marginRight: 8 }} icon={faSync} />
								}
							</div>
						</div>
						<div className='buttonGreen' style={{ borderRadius: 24, display: 'flex', justifyContent: 'space-between', alignItems: 'center', overflow: 'hidden', flex: '1 1 0px' }} onClick={() => emailQuote()}>
							<div style={{ width: 28, height: 24 }}>
								<img style={{ width: 24, height: 24, marginRight: 8 }} src={icon_email} alt='Email-Icon' />
							</div>
							<div style={{ whiteSpace: 'nowrap', textOverflow: 'ellipsis', overflow: 'hidden' }}>Email Quote</div>
							<div style={{ width: 28, height: 24 }}>
								{quotes.quote.isEmailing &&
									<FontAwesomeIcon className='fa-spin' style={{ fontSize: 22, marginRight: 8 }} icon={faSync} />
								}
							</div>
						</div>
						<div className='buttonGreen' style={{ borderRadius: 24, display: 'flex', justifyContent: 'space-between', alignItems: 'center', overflow: 'hidden', flex: '1 1 0px' }} onClick={() => instructQuote("IF", ifid)}>
							<div style={{ width: 28, height: 24 }}>
								<img style={{ width: 24, height: 24, marginRight: 8 }} src={icon_thumb} alt='Thumb-Icon' />
							</div>
							<div style={{ whiteSpace: 'nowrap', textOverflow: 'ellipsis', overflow: 'hidden' }}>Instruct PLS</div>
							<div style={{ width: 28, height: 24 }}>
								{quotes.quote.isInstructing &&
									<FontAwesomeIcon className='fa-spin' style={{ fontSize: 22, marginRight: 8 }} icon={faSync} />
								}
							</div>
						</div>
					</div>
				}
			</div>

			<div style={{ overflow: 'hidden' }}>
				<div style={{ position: 'absolute', display: 'flex', width: '300%', transition: 'left 0.5s', left: quotes.offset }}>
					<div style={{ width: 'calc(100% - 15px)' }} id="QF">
						<div style={{ display: 'flex' }}>
						</div>

						<div id="QFScroll" style={{ overflowY: 'scroll', height: 'calc(100vh - 382px)' }} onScroll={handleScroll}>
							<div style={{ maxWidth: 1280, margin: 'auto', padding: 16 }}>
								<div style={{ display: 'flex', margin: 4 }}>
									<div className='row50'>
									</div>
									<div className='row50' style={{ display: 'flex', marginLeft: '15px' }}>
										<div style={{ width: 'fit-content', paddingRight: 8 }}>
											<input data-form-id={qfid} data-valid-type="*" className={getFormValidWithId(qfid, "quote_consent") ? undefined : 'error'} disabled={isAccepted} type='checkbox' value='1' id="quote_consent" name='quote_consent' checked={getFormValueWithId(qfid, "quote_consent") === 'true'} onChange={(e) => doFormOnChange(e)} />
										</div>
										<label htmlFor="quote_consent">We confirm that the client has consented to providing a quote on their behalf</label>
									</div>
								</div>

								{user.id === "128568" && <div style={{ display: 'flex', margin: 4 }}>
									<div className='row50'>
									</div>
									<div className='row50' style={{ display: 'flex', alignItems: 'flex-start', marginLeft: '15px' }}>
										<div style={{ width: 'fit-content', paddingRight: 8 }}>
											<input data-form-id={qfid} disabled={isAccepted} type='checkbox' id="nhg_client_consent" name='nhg_client_consent' checked={getFormValueWithId(qfid, "nhg_client_consent") === 'true'} onChange={(e) => doFormOnChange(e)} />
										</div>
										<label htmlFor="nhg_client_consent">We, NHG, confirm that the customer has consented for NHG to be kept informed on the progress of the quote and its acceptance or otherwise</label>
									</div>
								</div>}

								<div style={{ display: 'flex', margin: 4 }}>
									<div className='row50'>Customer Type:</div>
									<div className='row50' style={{ display: 'flex', alignItems: 'center' }}>
										<div className='row33' style={{ display: 'flex', alignItems: 'center' }}>
											<div style={{ padding: 8 }}>
												<input data-form-id={qfid} className={getFormValidWithId(qfid, "quote_customer_type") ? undefined : 'error'} disabled={isAccepted} type='radio' value='1' id="quote_customer_type_repeat" name='quote_customer_type' checked={getFormValueWithId(qfid, "quote_customer_type") === '1'} onChange={(e) => doFormOnChange(e)} />
											</div>
											<div className='flexGrow1'>
												<label htmlFor="quote_customer_type_repeat">Repeat Customer</label>
											</div>
										</div>
										<div className='row33' style={{ display: 'flex', alignItems: 'center' }}>
											<div style={{ padding: 8 }}>
												<input data-form-id={qfid} className={getFormValidWithId(qfid, "quote_customer_type") ? undefined : 'error'} disabled={isAccepted} type='radio' value='2' id="quote_customer_type_new" name='quote_customer_type' checked={getFormValueWithId(qfid, "quote_customer_type") === '2'} onChange={(e) => doFormOnChange(e)} />
											</div>
											<div className='flexGrow1'>
												<label htmlFor="quote_customer_type_new">New Customer</label>
											</div>
										</div>
									</div>
								</div>

								<div style={{ display: 'flex', margin: 4 }}>
									<div className='row50'>Customer Source:</div>
									<div className='row50'>
										<select data-form-id={qfid} disabled={true} value={getFormValueWithId(qfid, "quote_customer_source")} name='quote_customer_source' onChange={(e) => doFormOnChange(e)}>
											<option disabled={isAccepted} value='Developer'>Developer</option>
										</select>
									</div>
								</div>

								<div style={{ display: 'flex', margin: 4 }}>
									<div className='row50'>Property Department:</div>
									<div className='row50'>
										<select data-form-id={qfid} data-valid-type="*" className={getFormValidWithId(qfid, "quote_property_department") ? undefined : 'error'} disabled={isAccepted} value={getFormValueWithId(qfid, "quote_property_department")} name='quote_property_department' onChange={(e) => doFormOnChange(e)}>
											<option value=''>Please select...</option>
											<option value='New Build'>New Build</option>
											<option value='Residential'>Residential</option>
											<option value='Secured Lending'>Secured Lending</option>
										</select>
									</div>
								</div>

								<div style={{ display: 'none', margin: 4 }}>
									<div className='row50'>Is this a secured lending?</div>
									<div className='row50' style={{ display: 'flex', alignItems: 'center' }}>
										<div className='row33' style={{ display: 'flex', alignItems: 'center' }}>
											<div style={{ padding: 8 }}>
												<input data-form-id={qfid} className={getFormValidWithId(qfid, "quote_secured") ? undefined : 'error'} disabled={isAccepted} type='radio' value='1' id="quote_secured_yes" name='quote_secured' checked={getFormValueWithId(qfid, "quote_secured") === '1'} onChange={(e) => doFormOnChange(e)} />
											</div>
											<div className='flexGrow1'>
												<label htmlFor="quote_secured_yes">Yes</label>
											</div>
										</div>
										<div className='row33' style={{ display: 'flex', alignItems: 'center' }}>
											<div style={{ padding: 8 }}>
												<input data-form-id={qfid} className={getFormValidWithId(qfid, "quote_secured") ? undefined : 'error'} disabled={isAccepted} type='radio' value='2' id="quote_secured_no" name='quote_secured' checked={getFormValueWithId(qfid, "quote_secured") === '2' || getFormValueWithId(qfid, "quote_secured") === ''} onChange={(e) => doFormOnChange(e)} />
											</div>
											<div className='flexGrow1'>
												<label htmlFor="quote_secured_no">No</label>
											</div>
										</div>
									</div>
								</div>

								<div style={{ display: 'flex', margin: 4 }}>
									<div className='row50'>Introducer:</div>
									<div className='row50'>
										<select data-form-id={qfid} disabled={true} value={getFormValueWithId(qfid, "quote_introducer_id")} name='quote_introducer_id' onChange={(e) => doFormOnChange(e)}>
											<option key={introducer.introducerid} value={introducer.introducerid}> {introducer.introducer} ({introducer.introducerid})</option>
										</select>
									</div>
								</div>

								<div style={{ display: 'flex', margin: 4 }}>
									<div className='row50'>Site:</div>
									<div className='row50'>
										<select data-form-id={qfid} data-valid-type="*" className={getFormValidWithId(qfid, "quote_site_id") ? undefined : 'error'} disabled={isAccepted} value={getFormValueWithId(qfid, "quote_site_id")} name='quote_site_id' onChange={(e) => doFormOnChange(e)}>
											<option value=''>Please Select...</option>

											{(filteredSites || []).map((item: User.sitesState) => {
												return (
													<option key={item.siteid} value={item.siteid}> {item.site} ({item.siteid})</option>
												)
											})}

										</select>
									</div>
								</div>

								<div style={{ display: 'flex', margin: 4 }}>
									<div className='row50'>Scheme:</div>
									<div className='row50'>
										<select data-form-id={qfid} data-valid-type="*" className={getFormValidWithId(qfid, "quote_scheme_id") ? undefined : 'error'} disabled={isAccepted} value={getFormValueWithId(qfid, "quote_scheme_id")} name='quote_scheme_id' onChange={(e) => doFormOnChange(e)}>
											<option value=''>Please Select...</option>

											{(filteredSchemes || []).map((item: User.schemesState) => {
												return (
													<option key={item.schemeid} value={item.schemeid}> {item.scheme} ({item.schemeid})</option>
												)
											})}

										</select>
									</div>
								</div>

								{filteredDevelopers.length > 0 &&
									<div style={{ display: 'flex', margin: 4 }}>
										<div className='row50'>Developer:</div>
										<div className='row50'>
											<select data-form-id={qfid} data-valid-type="*" className={getFormValidWithId(qfid, "quote_developer_id") ? undefined : 'error'} disabled={isAccepted} value={getFormValueWithId(qfid, "quote_developer_id")} name='quote_developer_id' onChange={(e) => doFormOnChange(e)}>
												<option value=''>Please Select...</option>

												{(filteredDevelopers || []).map((item: User.developerState) => {
													return (
														<option key={item.developerid} value={item.developerid}> {item.developer} ({item.developerid})</option>
													)
												})}

											</select>
										</div>
									</div>
								}

								<div style={{ display: 'flex', margin: 4 }}>
									<div className='row50'>Loan Amount £</div>
									<div className='row50'>
										<input data-form-id={qfid} data-valid-type="*" className={getFormValidWithId(qfid, "quote_property_price") ? undefined : 'error'} disabled={isAccepted} type='number' value={getFormValueWithId(qfid, "quote_property_price")} name='quote_property_price' min='0' onChange={(e) => doFormOnChange(e)} />
									</div>
								</div>

								<div style={{ display: 'flex', margin: 4 }}>
									<div className='row50'>How many Clients?</div>
									<div className='row50'>
										<select data-form-id={qfid} data-valid-type="*" className={getFormValidWithId(qfid, "quote_nclients") ? undefined : 'error'} disabled={isAccepted} value={getFormValueWithId(qfid, "quote_nclients")} name='quote_nclients' onChange={(e) => doFormOnChange(e)}>
											<option value=''>Please Select...</option>
											<option value='1'>1</option>
											<option value='2'>2</option>
											<option value='3'>3</option>
											<option value='4'>4</option>
										</select>
									</div>
								</div>

								<div style={{ display: 'flex', margin: 4 }}>
									<div className='row50'>Remortgage requiring Deed of postponement?</div>
									<div className='row50' style={{ display: 'flex', alignItems: 'center' }}>
										<div className='row33' style={{ display: 'flex', alignItems: 'center' }}>
											<div style={{ padding: 8 }}>
												<input data-form-id={qfid} className={getFormValidWithId(qfid, "quote_remo_postpone") ? undefined : 'error'} disabled={isAccepted} type='radio' value='1' id="quote_remo_postpone_yes" name='quote_remo_postpone' checked={getFormValueWithId(qfid, "quote_remo_postpone") === '1'} onChange={(e) => doFormOnChange(e)} />
											</div>
											<div className='flexGrow1'>
												<label htmlFor="quote_remo_postpone_yes">Yes</label>
											</div>
										</div>
										<div className='row33' style={{ display: 'flex', alignItems: 'center' }}>
											<div style={{ padding: 8 }}>
												<input data-form-id={qfid} className={getFormValidWithId(qfid, "quote_remo_postpone") ? undefined : 'error'} disabled={isAccepted} type='radio' value='2' id="quote_remo_postpone_no" name='quote_remo_postpone' checked={getFormValueWithId(qfid, "quote_remo_postpone") === '2'} onChange={(e) => doFormOnChange(e)} />
											</div>
											<div className='flexGrow1'>
												<label htmlFor="quote_remo_postpone_no">No</label>
											</div>
										</div>
									</div>
								</div>

								<div style={{ display: 'flex', margin: 4 }}>
									<div className='row50'>Do you have more than one mortgage/loan to redeem on completion?</div>
									<div className='row50' style={{ display: 'flex', alignItems: 'center' }}>
										<div className='row33' style={{ display: 'flex', alignItems: 'center' }}>
											<div style={{ padding: 8 }}>
												<input data-form-id={qfid} className={getFormValidWithId(qfid, "quote_mortgage") ? undefined : 'error'} disabled={isAccepted} type='radio' value='1' id="quote_mortgage_yes" name='quote_mortgage' checked={getFormValueWithId(qfid, "quote_mortgage") === '1'} onChange={(e) => doFormOnChange(e)} />
											</div>
											<div className='flexGrow1'>
												<label htmlFor="quote_mortgage_yes">Yes</label>
											</div>
										</div>
										<div className='row33' style={{ display: 'flex', alignItems: 'center' }}>
											<div style={{ padding: 8 }}>
												<input data-form-id={qfid} className={getFormValidWithId(qfid, "quote_mortgage") ? undefined : 'error'} disabled={isAccepted} type='radio' value='2' id="quote_mortgage_no" name='quote_mortgage' checked={getFormValueWithId(qfid, "quote_mortgage") === '2'} onChange={(e) => doFormOnChange(e)} />
											</div>
											<div className='flexGrow1'>
												<label htmlFor="quote_mortgage_no">No</label>
											</div>
										</div>
									</div>
								</div>

								<div style={{ display: 'flex', margin: 4 }}>
									<div className='row50'>Is this a rental property?</div>
									<div className='row50' style={{ display: 'flex', alignItems: 'center' }}>
										<div className='row33' style={{ display: 'flex', alignItems: 'center' }}>
											<div style={{ padding: 8 }}>
												<input data-form-id={qfid} className={getFormValidWithId(qfid, "quote_rental") ? undefined : 'error'} disabled={isAccepted} type='radio' value='1' id="quote_rental_yes" name='quote_rental' checked={getFormValueWithId(qfid, "quote_rental") === '1'} onChange={(e) => doFormOnChange(e)} />
											</div>
											<div className='flexGrow1'>
												<label htmlFor="quote_rental_yes">Yes</label>
											</div>
										</div>
										<div className='row33' style={{ display: 'flex', alignItems: 'center' }}>
											<div style={{ padding: 8 }}>
												<input data-form-id={qfid} className={getFormValidWithId(qfid, "quote_rental") ? undefined : 'error'} disabled={isAccepted} type='radio' value='2' id="quote_rental_no" name='quote_rental' checked={getFormValueWithId(qfid, "quote_rental") === '2'} onChange={(e) => doFormOnChange(e)} />
											</div>
											<div className='flexGrow1'>
												<label htmlFor="quote_rental_no">No</label>
											</div>
										</div>
										<div className='row33' style={{ display: 'flex', alignItems: 'center' }}>
											<div style={{ padding: 8 }}>
												<input data-form-id={qfid} className={getFormValidWithId(qfid, "quote_rental") ? undefined : 'error'} disabled={isAccepted} type='radio' value='3' id="quote_rental_unknown" name='quote_rental' checked={getFormValueWithId(qfid, "quote_rental") === '3'} onChange={(e) => doFormOnChange(e)} />
											</div>
											<div className='flexGrow1'>
												<label htmlFor="quote_rental_unknown">Unknown</label>
											</div>
										</div>
									</div>
								</div>

								<div style={{ display: 'flex', margin: 4 }}>
									<div className='row50'>Is the property Freehold or Leasehold?</div>
									<div className='row50' style={{ display: 'flex', alignItems: 'center' }}>
										<div className='row33' style={{ display: 'flex', alignItems: 'center' }}>
											<div style={{ padding: 8 }}>
												<input data-form-id={qfid} className={getFormValidWithId(qfid, "quote_hold") ? undefined : 'error'} disabled={isAccepted} type='radio' value='F' id="quote_hold_f" name='quote_hold' checked={getFormValueWithId(qfid, "quote_hold") === 'F'} onChange={(e) => doFormOnChange(e)} />
											</div>
											<div className='flexGrow1'>
												<label htmlFor="quote_hold_f">Freehold</label>
											</div>
										</div>
										<div className='row33' style={{ display: 'flex', alignItems: 'center' }}>
											<div style={{ padding: 8 }}>
												<input data-form-id={qfid} className={getFormValidWithId(qfid, "quote_hold") ? undefined : 'error'} disabled={isAccepted} type='radio' value='L' id="quote_hold_l" name='quote_hold' checked={getFormValueWithId(qfid, "quote_hold") === 'L'} onChange={(e) => doFormOnChange(e)} />
											</div>
											<div className='flexGrow1'>
												<label htmlFor="quote_hold_l">Leasehold</label>
											</div>
										</div>
										<div className='row33' style={{ display: 'flex', alignItems: 'center' }}>
											<div style={{ padding: 8 }}>
												<input data-form-id={qfid} className={getFormValidWithId(qfid, "quote_hold") ? undefined : 'error'} disabled={isAccepted} type='radio' value='U' id="quote_hold_u" name='quote_hold' checked={getFormValueWithId(qfid, "quote_hold") === 'U'} onChange={(e) => doFormOnChange(e)} />
											</div>
											<div className='flexGrow1'>
												<label htmlFor="quote_hold_u">Unknown</label>
											</div>
										</div>
									</div>
								</div>

								<div style={{ display: 'flex', margin: 4 }}>
									<div className='row50'>Are you adding and/or removing someone from the property ownership?</div>
									<div className='row50' style={{ display: 'flex', alignItems: 'center' }}>
										<div className='row33' style={{ display: 'flex', alignItems: 'center' }}>
											<div style={{ padding: 8 }}>
												<input data-form-id={qfid} className={getFormValidWithId(qfid, "quote_transfer") ? undefined : 'error'} disabled={isAccepted} type='radio' value='1' id="quote_transfer_yes" name='quote_transfer' checked={getFormValueWithId(qfid, "quote_transfer") === '1'} onChange={(e) => doFormOnChange(e)} />
											</div>
											<div className='flexGrow1'>
												<label htmlFor="quote_transfer_yes">Yes</label>
											</div>
										</div>
										<div className='row33' style={{ display: 'flex', alignItems: 'center' }}>
											<div style={{ padding: 8 }}>
												<input data-form-id={qfid} className={getFormValidWithId(qfid, "quote_transfer") ? undefined : 'error'} disabled={isAccepted} type='radio' value='2' id="quote_transfer_no" name='quote_transfer' checked={getFormValueWithId(qfid, "quote_transfer") === '2'} onChange={(e) => doFormOnChange(e)} />
											</div>
											<div className='flexGrow1'>
												<label htmlFor="quote_transfer_no">No</label>
											</div>
										</div>
										<div className='row33' style={{ display: 'flex', alignItems: 'center' }}>
											<div style={{ padding: 8 }}>
												<input data-form-id={qfid} className={getFormValidWithId(qfid, "quote_transfer") ? undefined : 'error'} disabled={isAccepted} type='radio' value='3' id="quote_transfer_unknown" name='quote_transfer' checked={getFormValueWithId(qfid, "quote_transfer") === '3'} onChange={(e) => doFormOnChange(e)} />
											</div>
											<div className='flexGrow1'>
												<label htmlFor="quote_transfer_unknown">Unknown</label>
											</div>
										</div>
									</div>
								</div>

								{getFormValueWithId(qfid, "quote_transfer") === "1" &&
									<div style={{ display: 'flex', margin: 4 }}>
										<div className='row50'>Please specify:</div>
										<div className='row50' style={{ display: 'flex', alignItems: 'center' }}>
											<div className='row33' style={{ display: 'flex', alignItems: 'center' }}>
												<div style={{ padding: 8 }}>
													<input data-form-id={qfid} className={getFormValidWithId(qfid, "quote_transfer_type") ? undefined : 'error'} disabled={isAccepted} type='radio' value='1' id="quote_transfer_type_add" name='quote_transfer_type' checked={getFormValueWithId(qfid, "quote_transfer_type") === '1'} onChange={(e) => doFormOnChange(e)} />
												</div>
												<div className='flexGrow1'>
													<label htmlFor="quote_transfer_type_add">Adding</label>
												</div>
											</div>
											<div className='row33' style={{ display: 'flex', alignItems: 'center' }}>
												<div style={{ padding: 8 }}>
													<input data-form-id={qfid} className={getFormValidWithId(qfid, "quote_transfer_type") ? undefined : 'error'} disabled={isAccepted} type='radio' value='2' id="quote_transfer_type_remove" name='quote_transfer_type' checked={getFormValueWithId(qfid, "quote_transfer_type") === '2'} onChange={(e) => doFormOnChange(e)} />
												</div>
												<div className='flexGrow1'>
													<label htmlFor="quote_transfer_type_remove">Removing</label>
												</div>
											</div>
											<div className='row33' style={{ display: 'flex', alignItems: 'center' }}>
												<div style={{ padding: 8 }}>
													<input data-form-id={qfid} className={getFormValidWithId(qfid, "quote_transfer_type") ? undefined : 'error'} disabled={isAccepted} type='radio' value='3' id="quote_transfer_type_both" name='quote_transfer_type' checked={getFormValueWithId(qfid, "quote_transfer_type") === '3'} onChange={(e) => doFormOnChange(e)} />
												</div>
												<div className='flexGrow1'>
													<label htmlFor="quote_transfer_type_both">Both</label>
												</div>
											</div>
										</div>
									</div>
								}

								{getFormValueWithId(qfid, "quote_transfer") === "1" &&
									<div>
										<div style={{ display: 'flex', margin: 4 }}>
											<div className='row50'>What is the property value?</div>
											<div className='row50'>
												<input data-form-id={qfid} data-valid-type="*" className={getFormValidWithId(qfid, "quote_property_price_initial") ? undefined : 'error'} disabled={isAccepted} type='number' value={getFormValueWithId(qfid, "quote_property_price_initial")} name='quote_property_price_initial' min='0' onChange={(e) => doFormOnChange(e)} />
											</div>
										</div>
										<div style={{ display: 'flex', margin: 4 }}>
											<div className='row50'>What is (roughly) the outstanding mortgage on the property?</div>
											<div className='row50'>
												<input data-form-id={qfid} data-valid-type="*" className={getFormValidWithId(qfid, "quote_mortgage_outstanding") ? undefined : 'error'} disabled={isAccepted} type='number' value={getFormValueWithId(qfid, "quote_mortgage_outstanding")} name='quote_mortgage_outstanding' min='0' onChange={(e) => doFormOnChange(e)} />
											</div>
										</div>
									</div>
								}

								{getFormValueWithId(qfid, "quote_transfer") === "1" && (getFormValueWithId(qfid, "quote_transfer_type") === "2" || getFormValueWithId(qfid, "quote_transfer_type") === "3") &&
									<div style={{ display: 'flex', margin: 4 }}>
										<div className='row50'>Is this transaction part of a divorce/matrimonial proceedings?</div>
										<div className='row50' style={{ display: 'flex', alignItems: 'center' }}>
											<div className='row33' style={{ display: 'flex', alignItems: 'center' }}>
												<div style={{ padding: 8 }}>
													<input data-form-id={qfid} className={getFormValidWithId(qfid, "quote_divorce") ? undefined : 'error'} disabled={isAccepted} type='radio' value='1' id="quote_divorce_yes" name='quote_divorce' checked={getFormValueWithId(qfid, "quote_divorce") === '1'} onChange={(e) => doFormOnChange(e)} />
												</div>
												<div className='flexGrow1'>
													<label htmlFor="quote_divorce_yes">Yes</label>
												</div>
											</div>
											<div className='row33' style={{ display: 'flex', alignItems: 'center' }}>
												<div style={{ padding: 8 }}>
													<input data-form-id={qfid} className={getFormValidWithId(qfid, "quote_divorce") ? undefined : 'error'} disabled={isAccepted} type='radio' value='2' id="quote_divorce_no" name='quote_divorce' checked={getFormValueWithId(qfid, "quote_divorce") === '2'} onChange={(e) => doFormOnChange(e)} />
												</div>
												<div className='flexGrow1'>
													<label htmlFor="quote_divorce_no">No</label>
												</div>
											</div>
										</div>
									</div>
								}

								{getFormValueWithId(qfid, "quote_transfer") === "1" && getFormValueWithId(qfid, "quote_divorce") === "1" && (getFormValueWithId(qfid, "quote_transfer_type") === "2" || getFormValueWithId(qfid, "quote_transfer_type") === "3") &&
									<div style={{ display: 'flex', margin: 4 }}>
										<div className='row50'>Do they have a sealed Court Order?</div>
										<div className='row50' style={{ display: 'flex', alignItems: 'center' }}>
											<div className='row33' style={{ display: 'flex', alignItems: 'center' }}>
												<div style={{ padding: 8 }}>
													<input data-form-id={qfid} className={getFormValidWithId(qfid, "quote_sealed") ? undefined : 'error'} disabled={isAccepted} type='radio' value='1' id="quote_sealed_yes" name='quote_sealed' checked={getFormValueWithId(qfid, "quote_sealed") === '1'} onChange={(e) => doFormOnChange(e)} />
												</div>
												<div className='flexGrow1'>
													<label htmlFor="quote_sealed_yes">Yes</label>
												</div>
											</div>
											<div className='row33' style={{ display: 'flex', alignItems: 'center' }}>
												<div style={{ padding: 8 }}>
													<input data-form-id={qfid} className={getFormValidWithId(qfid, "quote_sealed") ? undefined : 'error'} disabled={isAccepted} type='radio' value='2' id="quote_sealed_no" name='quote_sealed' checked={getFormValueWithId(qfid, "quote_sealed") === '2'} onChange={(e) => doFormOnChange(e)} />
												</div>
												<div className='flexGrow1'>
													<label htmlFor="quote_sealed_no">No</label>
												</div>
											</div>
										</div>
									</div>
								}

								<div style={{ display: 'flex', margin: 4 }}>
									<div className='row50'>Are you based overseas?</div>
									<div className='row50' style={{ display: 'flex', alignItems: 'center' }}>
										<div className='row33' style={{ display: 'flex', alignItems: 'center' }}>
											<div style={{ padding: 8 }}>
												<input data-form-id={qfid} className={getFormValidWithId(qfid, "quote_overseas") ? undefined : 'error'} disabled={isAccepted} type='radio' value='1' id="quote_overseas_yes" name='quote_overseas' checked={getFormValueWithId(qfid, "quote_overseas") === '1'} onChange={(e) => doFormOnChange(e)} />
											</div>
											<div className='flexGrow1'>
												<label htmlFor="quote_overseas_yes">Yes</label>
											</div>
										</div>
										<div className='row33' style={{ display: 'flex', alignItems: 'center' }}>
											<div style={{ padding: 8 }}>
												<input data-form-id={qfid} className={getFormValidWithId(qfid, "quote_overseas") ? undefined : 'error'} disabled={isAccepted} type='radio' value='2' id="quote_overseas_no" name='quote_overseas' checked={getFormValueWithId(qfid, "quote_overseas") === '2'} onChange={(e) => doFormOnChange(e)} />
											</div>
											<div className='flexGrow1'>
												<label htmlFor="quote_overseas_no">No</label>
											</div>
										</div>
									</div>
								</div>

								<div style={{ display: 'flex', margin: 4 }}>
									<div className='row50'>Are all the clients based in the U.K.?</div>
									<div className='row50' style={{ display: 'flex', alignItems: 'center' }}>
										<div className='row33' style={{ display: 'flex', alignItems: 'center' }}>
											<div style={{ padding: 8 }}>
												<input data-form-id={qfid} className={getFormValidWithId(qfid, "quote_client_uk") ? undefined : 'error'} disabled={isAccepted} type='radio' value='1' id="quote_client_uk_yes" name='quote_client_uk' checked={getFormValueWithId(qfid, "quote_client_uk") === '1'} onChange={(e) => doFormOnChange(e)} />
											</div>
											<div className='flexGrow1'>
												<label htmlFor="quote_client_uk_yes">Yes</label>
											</div>
										</div>
										<div className='row33' style={{ display: 'flex', alignItems: 'center' }}>
											<div style={{ padding: 8 }}>
												<input data-form-id={qfid} className={getFormValidWithId(qfid, "quote_client_uk") ? undefined : 'error'} disabled={isAccepted} type='radio' value='2' id="quote_client_uk_no" name='quote_client_uk' checked={getFormValueWithId(qfid, "quote_client_uk") === '2'} onChange={(e) => doFormOnChange(e)} />
											</div>
											<div className='flexGrow1'>
												<label htmlFor="quote_client_uk_no">No</label>
											</div>
										</div>
									</div>
								</div>

								{getFormValueWithId(qfid, "quote_htb") === "1" &&
									<div style={{ display: 'flex', margin: 4, flexWrap: 'wrap' }}>
										<div className='row50'>Have you submitted Valuation request?</div>
										<div className='row50' style={{ display: 'flex', alignItems: 'center' }}>
											<div className='row33' style={{ display: 'flex', alignItems: 'center' }}>
												<div style={{ padding: 8 }}>
													<input data-form-id={qfid} className={getFormValidWithId(qfid, "quote_htb_valreq") ? undefined : 'error'} disabled={isAccepted} type='radio' value='1' id="quote_htb_valreq_yes" name='quote_htb_valreq' checked={getFormValueWithId(qfid, "quote_htb_valreq") === '1'} onChange={(e) => doFormOnChange(e)} />
												</div>
												<div className='flexGrow1'>
													<label htmlFor="quote_htb_valreq_yes">Yes</label>
												</div>
											</div>
											<div className='row33' style={{ display: 'flex', alignItems: 'center' }}>
												<div style={{ padding: 8 }}>
													<input data-form-id={qfid} className={getFormValidWithId(qfid, "quote_htb_valreq") ? undefined : 'error'} disabled={isAccepted} type='radio' value='2' id="quote_htb_valreq_no" name='quote_htb_valreq' checked={getFormValueWithId(qfid, "quote_htb_valreq") === '2'} onChange={(e) => doFormOnChange(e)} />
												</div>
												<div className='flexGrow1'>
													<label htmlFor="quote_htb_valreq_no">No</label>
												</div>
											</div>
										</div>
										<div className='row50'>Has Admin fee To Target been paid?</div>
										<div className='row50' style={{ display: 'flex', alignItems: 'center' }}>
											<div className='row33' style={{ display: 'flex', alignItems: 'center' }}>
												<div style={{ padding: 8 }}>
													<input data-form-id={qfid} className={getFormValidWithId(qfid, "quote_htb_feepaid") ? undefined : 'error'} disabled={isAccepted} type='radio' value='1' id="quote_htb_feepaid_yes" name='quote_htb_feepaid' checked={getFormValueWithId(qfid, "quote_htb_valreq") === '1'} onChange={(e) => doFormOnChange(e)} />
												</div>
												<div className='flexGrow1'>
													<label htmlFor="quote_htb_valreq_yes">Yes</label>
												</div>
											</div>
											<div className='row33' style={{ display: 'flex', alignItems: 'center' }}>
												<div style={{ padding: 8 }}>
													<input data-form-id={qfid} className={getFormValidWithId(qfid, "quote_htb_feepaid") ? undefined : 'error'} disabled={isAccepted} type='radio' value='2' id="quote_htb_feepaid_no" name='quote_htb_feepaid' checked={getFormValueWithId(qfid, "quote_htb_valreq") === '2'} onChange={(e) => doFormOnChange(e)} />
												</div>
												<div className='flexGrow1'>
													<label htmlFor="quote_htb_valreq_no">No</label>
												</div>
											</div>
										</div>
										<div className='row50'>Have you advised Target that PLS are acting?</div>
										<div className='row50' style={{ display: 'flex', alignItems: 'center' }}>
											<div className='row33' style={{ display: 'flex', alignItems: 'center' }}>
												<div style={{ padding: 8 }}>
													<input data-form-id={qfid} className={getFormValidWithId(qfid, "quote_htb_plsact") ? undefined : 'error'} disabled={isAccepted} type='radio' value='1' id="quote_htb_plsact_yes" name='quote_htb_plsact' checked={getFormValueWithId(qfid, "quote_htb_plsact") === '1'} onChange={(e) => doFormOnChange(e)} />
												</div>
												<div className='flexGrow1'>
													<label htmlFor="quote_htb_plsact_yes">Yes</label>
												</div>
											</div>
											<div className='row33' style={{ display: 'flex', alignItems: 'center' }}>
												<div style={{ padding: 8 }}>
													<input data-form-id={qfid} className={getFormValidWithId(qfid, "quote_htb_plsact") ? undefined : 'error'} disabled={isAccepted} type='radio' value='2' id="quote_htb_plsact_no" name='quote_htb_plsact' checked={getFormValueWithId(qfid, "quote_htb_plsact") === '2'} onChange={(e) => doFormOnChange(e)} />
												</div>
												<div className='flexGrow1'>
													<label htmlFor="quote_htb_plsact_no">No</label>
												</div>
											</div>
										</div>
									</div>
								}

								<div style={{ display: 'flex', margin: 4 }}>
									<div className='row50'>Are you redeeming any Help to Buy loans?</div>
									<div className='row50' style={{ display: 'flex', alignItems: 'center' }}>
										<div className='row33' style={{ display: 'flex', alignItems: 'center' }}>
											<div style={{ padding: 8 }}>
												<input data-form-id={qfid} className={getFormValidWithId(qfid, "quote_htb") ? undefined : 'error'} disabled={isAccepted} type='radio' value='1' id="quote_htb_yes" name='quote_htb' checked={getFormValueWithId(qfid, "quote_htb") === '1'} onChange={(e) => doFormOnChange(e)} />
											</div>
											<div className='flexGrow1'>
												<label htmlFor="quote_htb_yes">Yes</label>
											</div>
										</div>
										<div className='row33' style={{ display: 'flex', alignItems: 'center' }}>
											<div style={{ padding: 8 }}>
												<input data-form-id={qfid} className={getFormValidWithId(qfid, "quote_htb") ? undefined : 'error'} disabled={isAccepted} type='radio' value='2' id="quote_htb_no" name='quote_htb' checked={getFormValueWithId(qfid, "quote_htb") === '2'} onChange={(e) => doFormOnChange(e)} />
											</div>
											<div className='flexGrow1'>
												<label htmlFor="quote_htb_no">No</label>
											</div>
										</div>
									</div>
								</div>

								<div style={{ display: 'flex', margin: 4 }}>
									<div className='row50'>Are you increasing your ownership percentage of the property (staircasing shared ownership)?</div>
									<div className='row50' style={{ display: 'flex', alignItems: 'center' }}>
										<div className='row33' style={{ display: 'flex', alignItems: 'center' }}>
											<div style={{ padding: 8 }}>
												<input data-form-id={qfid} className={getFormValidWithId(qfid, "quote_increase") ? undefined : 'error'} disabled={isAccepted} type='radio' value='1' id="quote_increase_yes" name='quote_increase' checked={getFormValueWithId(qfid, "quote_increase") === '1'} onChange={(e) => doFormOnChange(e)} />
											</div>
											<div className='flexGrow1'>
												<label htmlFor="quote_increase_yes">Yes</label>
											</div>
										</div>
										<div className='row33' style={{ display: 'flex', alignItems: 'center' }}>
											<div style={{ padding: 8 }}>
												<input data-form-id={qfid} className={getFormValidWithId(qfid, "quote_increase") ? undefined : 'error'} disabled={isAccepted} type='radio' value='2' id="quote_increase_no" name='quote_increase' checked={getFormValueWithId(qfid, "quote_increase") === '2'} onChange={(e) => doFormOnChange(e)} />
											</div>
											<div className='flexGrow1'>
												<label htmlFor="quote_increase_no">No</label>
											</div>
										</div>
									</div>
								</div>

								<div style={{ fontFamily: 'OpenSans-Bold', margin: 4, marginTop: 14 }}>Your Details</div>

								<div style={{ display: 'flex', margin: 4 }}>
									<div className='row50'>
										<label htmlFor='quote_first_name'>First Name:</label>
									</div>
									<div className='row50'>
										<input data-form-id={qfid} data-valid-type="*" className={getFormValidWithId(qfid, "quote_first_name") ? undefined : 'error'} disabled={isAccepted} type='text' value={getFormValueWithId(qfid, "quote_first_name")} name='quote_first_name' id='quote_first_name' onChange={(e) => doFormOnChange(e)} />
									</div>
								</div>

								<div style={{ display: 'flex', margin: 4 }}>
									<div className='row50'>
										<label htmlFor='quote_surname'>Surname:</label>
									</div>
									<div className='row50'>
										<input data-form-id={qfid} data-valid-type="*" className={getFormValidWithId(qfid, "quote_surname") ? undefined : 'error'} disabled={isAccepted} type='text' value={getFormValueWithId(qfid, "quote_surname")} name='quote_surname' id='quote_surname' onChange={(e) => doFormOnChange(e)} />
									</div>
								</div>

								<div style={{ display: 'flex', margin: 4 }}>
									<div className='row50'>
										<label htmlFor='quote_email'>Email Address:</label>
									</div>
									<div className='row50' style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', gap: '3px'}}>
										<input data-form-id={qfid} data-valid-type="email" data-valid-message='Please enter a valid Email address' className={getFormValidWithId(qfid, "quote_email") ? undefined : 'error'} disabled={isAccepted} type='text' value={getFormValueWithId(qfid, "quote_email")} name='quote_email' id='quote_email' onChange={(e) => doFormOnChange(e)} />
										{!getFormValidWithId(qfid, 'quote_email') &&
											<div style={{ color: 'red', fontSize: '14px' }}>{getFormMessageWithId(qfid, 'quote_email')}</div>
										}
									</div>
								</div>

								<div style={{ display: 'flex', margin: 4 }}>
									<div className='row50'>
										<label htmlFor='quote_mobile'>Mobile Phone No:</label>
									</div>
									<div className='row50'>
										<input data-form-id={qfid} data-valid-type="*" className={getFormValidWithId(qfid, "quote_mobile") ? undefined : 'error'} disabled={isAccepted} type='text' value={getFormValueWithId(qfid, "quote_mobile")} name='quote_mobile' id='quote_mobile' onChange={(e) => doFormOnChange(e)} />
									</div>
								</div>

								{user.id === "128568" && <div className='NHG_details'>
									<div style={{ fontFamily: 'OpenSans-Bold', margin: 4 }}>New Homes Group Details</div>

									<div style={{ display: 'flex', margin: 4 }}>
										<div className='row50'>
											<label htmlFor='staff_name_NHG'>Staff Name</label>
										</div>
										<div className='row50'>
											<input data-form-id={qfid} data-valid-type="*" className={getFormValidWithId(qfid, "staff_name_NHG") ? undefined : 'error'} disabled={isAccepted} type='text' value={getFormValueWithId(qfid, "staff_name_NHG")} name='staff_name_NHG' id='staff_name_NHG' onChange={(e) => doFormOnChange(e)} />
										</div>
									</div>

									<div style={{ display: 'flex', margin: 4 }}>
										<div className='row50'>
											<label htmlFor='staff_email_NHG'>Staff Email</label>
										</div>
										<div className='row50'>
											<input data-form-id={qfid} data-valid-type="*" className={getFormValidWithId(qfid, "staff_email_NHG") ? undefined : 'error'} disabled={isAccepted} type='text' value={getFormValueWithId(qfid, "staff_email_NHG")} name='staff_email_NHG' id='staff_email_NHG' onChange={(e) => doFormOnChange(e)} />
										</div>
									</div>

									<div style={{ display: 'flex', margin: 4 }}>
										<div className='row50'>
											<label htmlFor='zoe_email_NHG'>Zoe's Email</label>
										</div>
										<div className='row50'>
											<input type='text' value="Zoe.Sturgess@tnhg.co.uk" id='zoe_email_NHG' disabled />
										</div>
									</div>

									{user.id === "128568" && <div style={{ display: 'flex', margin: 4 }}>
										<div className='row50'>
											<label htmlFor='NHG_n'>NHG n.</label>
										</div>
										<div className='row50'>
											<input type="text" value="128568" id="NHG_n" disabled />
										</div>
									</div>}
								</div>}

								{user.id === "566278" && <div className='NHG_details'>
									<div style={{ fontFamily: 'OpenSans-Bold', margin: 4 }}>Consultant and Site Information</div>

									<div style={{ display: 'flex', margin: 4 }}>
										<div className='row50'>
											<label htmlFor='staff_name_Leadersromansgroup'>Your Name</label>
										</div>
										<div className='row50'>
											<select id="staff_name_Leadersromansgroup" data-form-id={qfid} data-valid-type="*" className={getFormValidWithId(qfid, "staff_name_Leadersromansgroup") ? undefined : 'error'} disabled={isAccepted} value={getFormValueWithId(qfid, "staff_name_Leadersromansgroup")} name='staff_name_Leadersromansgroup' onChange={(e) => { doFormOnChange(e); onStaffSelect(e) }} >
												<option value="">Please Select...</option>
												<option value="Adrian Plant">Adrian Plant</option>
												<option value="Bernardo Lourenco">Bernardo Lourenco</option>
												<option value="Gemma Gibson">Gemma Gibson</option>
												<option value="Jake Butler">Jake Butler</option>
												<option value="Kornelija Zilinskaite">Kornelija Zilinskaite</option>
												<option value="Lyndon Farrar">Lyndon Farrar</option>
												<option value="Monic Chhabria">Monic Chhabria</option>
												<option value="Peter Hawley">Peter Hawley</option>
												<option value="Sanjay Paul">Sanjay Paul</option>
												<option value="Tia Redmile">Tia Redmile</option>
												<option value="Rumon Kauser">Rumon Kauser</option>
												<option value="Natalie Painter">Natalie Painter</option>
												<option value="Patrick Hill">Patrick Hill</option>
											</select>
										</div>
									</div>

									<div style={{ display: 'flex', margin: 4 }}>
										<div className='row50'>
											<label htmlFor='staff_email_Leadersromansgroup'>Your Email</label>
										</div>
										<div className='row50'>
											<input data-form-id={qfid} data-valid-type="*" className={getFormValidWithId(qfid, "staff_email_Leadersromansgroup") ? undefined : 'error'} disabled type='text' name='staff_email_Leadersromansgroup' id='staff_email_Leadersromansgroup' onChange={(e) => doFormOnChange(e)} />
										</div>
									</div>

									<div style={{ display: 'flex', margin: 4 }}>
										<div className='row50'>
											<label htmlFor='site_name_Leadersromansgroup'>Site Name</label>
										</div>
										<div className='row50'>
											<input data-form-id={qfid} data-valid-type="*" className={getFormValidWithId(qfid, "site_name_Leadersromansgroup") ? undefined : 'error'} disabled={isAccepted} type='text' value={getFormValueWithId(qfid, "site_name_Leadersromansgroup")} name='site_name_Leadersromansgroup' id='site_name_Leadersromansgroup' onChange={(e) => doFormOnChange(e)} />
										</div>
									</div>

									<div style={{ display: 'flex', margin: 4 }}>
										<div className='row50'>
											<label htmlFor='developer_name_Leadersromansgroup'>Developer Name</label>
										</div>
										<div className='row50'>
											<input data-form-id={qfid} data-valid-type="*" className={getFormValidWithId(qfid, "developer_name_Leadersromansgroup") ? undefined : 'error'} disabled={isAccepted} type='text' value={getFormValueWithId(qfid, "developer_name_Leadersromansgroup")} name='developer_name_Leadersromansgroup' id='developer_name_Leadersromansgroup' onChange={(e) => doFormOnChange(e)} />
										</div>
									</div>
								</div>}
							</div>
						</div>
					</div>

					<div style={{ width: 'calc(100% - 15px)' }} id="QS">
						<div style={{ display: 'flex' }}>
						</div>
						<div id="QSScroll" style={{ overflowY: 'scroll', height: 'calc(100vh - 382px)' }}>
							<div id="QSContent">
								{quotes.quote.quotebreakdown &&
									<QuoteSummary />
								}
							</div>
						</div>
					</div>

					<div style={{ width: 'calc(100% - 15px)' }} id="IF">
						<div style={{ display: 'flex' }}>
						</div>

						<div id="IFScroll" style={{ overflowY: 'scroll', height: 'calc(100vh - 382px)' }} onScroll={handleScroll}>
							<div style={{ maxWidth: 1280, margin: 'auto', padding: 16 }}>
								<div style={{ fontFamily: 'OpenSans-Bold', margin: 4 }}>Remortgage Property Details</div>

								<div>
									<div style={{ display: 'flex', margin: 4 }}>
										<div className='row50'>
											<label htmlFor='property_address_house'>House No./Name:</label>
										</div>
										<div className='row50'>
											<input data-form-id={ifid} data-valid-type="*" className={getFormValidWithId(ifid, "property_address_house") ? undefined : 'error'} disabled={isInstructed} type='text' value={getFormValueWithId(ifid, "property_address_house")} name='property_address_house' id='property_address_house' onChange={(e) => doFormOnChange(e)} />
										</div>
									</div>

									<div style={{ display: 'flex', margin: 4 }}>
										<div className='row50'>
											<label htmlFor='property_address_street'>Street:</label>
										</div>
										<div className='row50'>
											<input data-form-id={ifid} data-valid-type="*" className={getFormValidWithId(ifid, "property_address_street") ? undefined : 'error'} disabled={isInstructed} type='text' value={getFormValueWithId(ifid, "property_address_street")} name='property_address_street' id='property_address_street' onChange={(e) => doFormOnChange(e)} />
										</div>
									</div>

									<div style={{ display: 'flex', margin: 4 }}>
										<div className='row50'>
											<label htmlFor='property_address_town'>Town:</label>
										</div>
										<div className='row50'>
											<input data-form-id={ifid} data-valid-type="*" className={getFormValidWithId(ifid, "property_address_town") ? undefined : 'error'} disabled={isInstructed} type='text' value={getFormValueWithId(ifid, "property_address_town")} name='property_address_town' id='property_address_town' onChange={(e) => doFormOnChange(e)} />
										</div>
									</div>

									<div style={{ display: 'flex', margin: 4 }}>
										<div className='row50'>
											<label htmlFor='property_address_county'>County:</label>
										</div>
										<div className='row50'>
											<input data-form-id={ifid} disabled={isInstructed} type='text' value={getFormValueWithId(ifid, "property_address_county")} name='property_address_county' id='property_address_county' onChange={(e) => doFormOnChange(e)} />
										</div>
									</div>

									<div style={{ display: 'flex', margin: 4 }}>
										<div className='row50'>
											<label htmlFor='property_address_postcode'>Postcode:</label>
										</div>
										<div className='row50'>
											<input data-form-id={ifid} data-valid-type="*" className={getFormValidWithId(ifid, "property_address_postcode") ? undefined : 'error'} disabled={isInstructed} type='text' value={getFormValueWithId(ifid, "property_address_postcode")} name='property_address_postcode' id='property_address_postcode' onChange={(e) => doFormOnChange(e)} />
										</div>
									</div>

									<div style={{ display: 'flex', margin: 4 }}>
										<div className='row50'></div>
										<div className='row50'>
											<div className='buttonGreen' style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', overflow: 'hidden', flex: '1 1 0px' }} onClick={() => getPostcodeAddresses(ifid, 'property_address')}>
												<div style={{ display: 'flex' }}>
													<FontAwesomeIcon style={{ fontSize: 18, marginRight: 8 }} icon={faMagnifyingGlassLocation} />
													<div style={{ whiteSpace: 'nowrap', textOverflow: 'ellipsis', overflow: 'hidden' }}>Find Postcode</div>
												</div>
												{forms.isGettingAddress['property_address'] &&
													<FontAwesomeIcon className='fa-spin' style={{ fontSize: 18, marginRight: 8 }} icon={faSync} />
												}
											</div>
										</div>
									</div>

									{getAddressListWithId('property_address').length > 0 &&
										<div style={{ display: 'flex', margin: 4 }}>
											<div className='row50'>Select Address:</div>
											<div className='row50'>
												<select data-form-id={ifid} value={getFormValueWithId(ifid, "property_address")} name='property_address' onChange={(e) => selectAddress(e)}>
													<option value=''>Please Select...</option>
													{getAddressListWithId('property_address').map((item: Forms.postcodeAddressState, index: number) => {
														return (
															<option key={index} value={index}> {item.premise}, {item.street}, {item.posttown}, {item.county}.</option>
														)
													})}
												</select>
											</div>
										</div>
									}
								</div>

								<div className="main_rule"></div>
								<div style={{ fontFamily: 'OpenSans-Bold', margin: 4 }}>New Lender Information</div>

								<div>
									<div style={{ display: 'flex', margin: 4 }}>
										<div className='row50'>
											<label htmlFor='lender_name'>Lender Name:</label>
										</div>
										<div className='row50'>
											<input data-form-id={ifid} data-valid-type="*" className={getFormValidWithId(ifid, "lender_name") ? undefined : 'error'} disabled={isInstructed} type='text' value={getFormValueWithId(ifid, "lender_name")} name='lender_name' id='lender_name' onChange={(e) => doFormOnChange(e)} />
										</div>
									</div>

									<div style={{ display: 'flex', margin: 4 }}>
										<div className='row50'>
											<label htmlFor='lender_address_house'>Property No./Name:</label>
										</div>
										<div className='row50'>
											<input data-form-id={ifid} data-valid-type="*" className={getFormValidWithId(ifid, "lender_address_house") ? undefined : 'error'} disabled={isInstructed} type='text' value={getFormValueWithId(ifid, "lender_address_house")} name='lender_address_house' id='lender_address_house' onChange={(e) => doFormOnChange(e)} />
										</div>
									</div>

									<div style={{ display: 'flex', margin: 4 }}>
										<div className='row50'>
											<label htmlFor='lender_address_street'>Street:</label>
										</div>
										<div className='row50'>
											<input data-form-id={ifid} data-valid-type="*" className={getFormValidWithId(ifid, "lender_address_street") ? undefined : 'error'} disabled={isInstructed} type='text' value={getFormValueWithId(ifid, "lender_address_street")} name='lender_address_street' id='lender_address_street' onChange={(e) => doFormOnChange(e)} />
										</div>
									</div>

									<div style={{ display: 'flex', margin: 4 }}>
										<div className='row50'>
											<label htmlFor='lender_address_town'>Town:</label>
										</div>
										<div className='row50'>
											<input data-form-id={ifid} data-valid-type="*" className={getFormValidWithId(ifid, "lender_address_town") ? undefined : 'error'} disabled={isInstructed} type='text' value={getFormValueWithId(ifid, "lender_address_town")} name='lender_address_town' id='lender_address_town' onChange={(e) => doFormOnChange(e)} />
										</div>
									</div>

									<div style={{ display: 'flex', margin: 4 }}>
										<div className='row50'>
											<label htmlFor='lender_address_county'>County:</label>
										</div>
										<div className='row50'>
											<input data-form-id={ifid} disabled={isInstructed} type='text' value={getFormValueWithId(ifid, "lender_address_county")} name='lender_address_county' id='lender_address_county' onChange={(e) => doFormOnChange(e)} />
										</div>
									</div>

									<div style={{ display: 'flex', margin: 4 }}>
										<div className='row50'>
											<label htmlFor='lender_address_postcode'>Postcode:</label>
										</div>
										<div className='row50'>
											<input data-form-id={ifid} data-valid-type="*" className={getFormValidWithId(ifid, "lender_address_postcode") ? undefined : 'error'} disabled={isInstructed} type='text' value={getFormValueWithId(ifid, "lender_address_postcode")} name='lender_address_postcode' id='lender_address_postcode' onChange={(e) => doFormOnChange(e)} />
										</div>
									</div>

									<div style={{ display: 'flex', margin: 4 }}>
										<div className='row50'></div>
										<div className='row50'>
											<div className='buttonGreen' style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', overflow: 'hidden', flex: '1 1 0px' }} onClick={() => getPostcodeAddresses(ifid, 'lender_address')}>
												<div style={{ display: 'flex' }}>
													<FontAwesomeIcon style={{ fontSize: 18, marginRight: 8 }} icon={faMagnifyingGlassLocation} />
													<div style={{ whiteSpace: 'nowrap', textOverflow: 'ellipsis', overflow: 'hidden' }}>Find Postcode</div>
												</div>
												{forms.isGettingAddress['lender_address'] &&
													<FontAwesomeIcon className='fa-spin' style={{ fontSize: 18, marginRight: 8 }} icon={faSync} />
												}
											</div>
										</div>
									</div>

									{getAddressListWithId('lender_address').length > 0 &&
										<div style={{ display: 'flex', margin: 4 }}>
											<div className='row50'>Select Address:</div>
											<div className='row50'>
												<select data-form-id={ifid} value={getFormValueWithId(ifid, "lender_address")} name='lender_address' onChange={(e) => selectAddress(e)}>
													<option value=''>Please Select...</option>
													{getAddressListWithId('lender_address').map((item: Forms.postcodeAddressState, index: number) => {
														return (
															<option key={index} value={index}> {item.premise}, {item.street}, {item.posttown}, {item.county}.</option>
														)
													})}
												</select>
											</div>
										</div>
									}
								</div>

								<div className="main_rule"></div>
								<div style={{ fontFamily: 'OpenSans-Bold', margin: 4 }}>Remortgager 1 Details</div>

								<div style={{ display: 'flex', margin: 4 }}>
									<div className='row50'>Is this a Company or an Individual?</div>
									<div className='row50'>
										<select data-form-id={ifid} data-valid-type="*" className={getFormValidWithId(ifid, "c1_comp_or_ind") ? undefined : 'error'} disabled={isInstructed} value={getFormValueWithId(ifid, "c1_comp_or_ind")} name='c1_comp_or_ind' onChange={(e) => doFormOnChange(e)}>
											<option value=''>Please Select...</option>
											<option value='0'>Individual</option>
											<option value='1'>Company</option>
										</select>
									</div>
								</div>

								{getFormValueWithId(ifid, "c1_comp_or_ind") === "0" &&
									<div>
										<div style={{ fontFamily: 'OpenSans-Bold', margin: 4 }}>Client 1 Details</div>

										<div style={{ display: 'flex', margin: 4 }}>
											<div className='row50'>Title:</div>
											<div className='row50'>
												<select data-form-id={ifid} data-valid-type="*" className={getFormValidWithId(ifid, "c1_title") ? undefined : 'error'} disabled={isInstructed} value={getFormValueWithId(ifid, "c1_title")} name='c1_title' onChange={(e) => doFormOnChange(e)}>
													<option value=''>Please Select...</option>
													<option value='Miss'>Miss</option>
													<option value='Ms'>Ms</option>
													<option value='Mrs'>Mrs</option>
													<option value='Mr'>Mr</option>
													<option value='Dr'>Dr</option>
													<option value='Other'>Other</option>
												</select>
											</div>
										</div>

										{getFormValueWithId(ifid, "c1_title") === "Other" &&
											<div style={{ display: 'flex', margin: 4 }}>
												<div className='row50'>
													<label htmlFor='c1_title_specify'>Please Specify:</label>
												</div>
												<div className='row50'>
													<input data-form-id={ifid} data-valid-type="*" className={getFormValidWithId(ifid, "c1_title_specify") ? undefined : 'error'} disabled={isInstructed} type='text' value={getFormValueWithId(ifid, "c1_title_specify")} name='c1_title_specify' id='c1_title_specify' onChange={(e) => doFormOnChange(e)} />
												</div>
											</div>
										}

										<div style={{ display: 'flex', margin: 4 }}>
											<div className='row50'>
												<label htmlFor='c1_firstname'>First Name:</label>
											</div>
											<div className='row50'>
												<input data-form-id={ifid} data-valid-type="*" className={getFormValidWithId(ifid, "c1_firstname") ? undefined : 'error'} disabled={isInstructed} type='text' value={getFormValueWithId(ifid, "c1_firstname")} name='c1_firstname' id='c1_firstname' onChange={(e) => doFormOnChange(e)} />
											</div>
										</div>

										<div style={{ display: 'flex', margin: 4 }}>
											<div className='row50'>
												<label htmlFor='c1_middlenames'>Middle Names:</label>
											</div>
											<div className='row50'>
												<input data-form-id={ifid} disabled={isInstructed} type='text' value={getFormValueWithId(ifid, "c1_middlenames")} name='c1_middlenames' id='c1_middlenames' onChange={(e) => doFormOnChange(e)} />
											</div>
										</div>

										<div style={{ display: 'flex', margin: 4 }}>
											<div className='row50'>
												<label htmlFor='c1_surname'>Surname:</label>
											</div>
											<div className='row50'>
												<input data-form-id={ifid} data-valid-type="*" className={getFormValidWithId(ifid, "c1_surname") ? undefined : 'error'} disabled={isInstructed} type='text' value={getFormValueWithId(ifid, "c1_surname")} name='c1_surname' id='c1_surname' onChange={(e) => doFormOnChange(e)} />
											</div>
										</div>

										<div style={{ display: 'flex', margin: 4 }}>
											<div className='row50'>
												<label htmlFor='c1_email'>Email Address:</label>
											</div>
											<div className='row50' style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', gap: '3px'}}>
												<input data-form-id={ifid} data-valid-type="email" data-valid-message='Please enter a valid Email address' className={getFormValidWithId(ifid, "c1_email") ? undefined : 'error'} disabled={isInstructed} type='text' value={getFormValueWithId(ifid, "c1_email")} name='c1_email' id='c1_email' onChange={(e) => doFormOnChange(e)} />
												{!getFormValidWithId(ifid, 'c1_email') &&
													<div style={{ color: 'red', fontSize: '14px' }}>{getFormMessageWithId(ifid, 'c1_email')}</div>
												}
											</div>
										</div>

										<div style={{ display: 'flex', margin: 4 }}>
											<div className='row50'>
												<label htmlFor='c1_main_number'>Home Phone No:</label>
											</div>
											<div className='row50'>
												<input data-form-id={ifid} disabled={isInstructed} type='text' value={getFormValueWithId(ifid, "c1_main_number")} name='c1_main_number' id='c1_main_number' onChange={(e) => doFormOnChange(e)} />
											</div>
										</div>

										<div style={{ display: 'flex', margin: 4 }}>
											<div className='row50'>
												<label htmlFor='c1_mobile_number'>Mobile Phone No:</label>
											</div>
											<div className='row50'>
												<input data-form-id={ifid} data-valid-type="*" className={getFormValidWithId(ifid, "c1_mobile_number") ? undefined : 'error'} disabled={isInstructed} type='text' value={getFormValueWithId(ifid, "c1_mobile_number")} name='c1_mobile_number' id='c1_mobile_number' onChange={(e) => doFormOnChange(e)} />
											</div>
										</div>

										<div style={{ display: 'flex', margin: 4 }}>
											<div className='row50'>
												<div style={{ display: 'flex', flexDirection: 'column' }}>
													<div>Is Client 1 a UK Resident?</div>
													<div style={{ fontSize: 12 }}>For more information please click <a href="https://www.gov.uk/government/publications/rdr3-statutory-residence-test-srt" target="_blank">here</a></div>
												</div>
											</div>
											<div className='row50' style={{ display: 'flex', alignItems: 'center' }}>
												<div className='row33' style={{ display: 'flex', alignItems: 'center' }}>
													<div style={{ padding: 8 }}>
														<input data-form-id={ifid} className={getFormValidWithId(ifid, "c1_uk_resident") ? undefined : 'error'} disabled={isInstructed} type='radio' value='1' id="c1_uk_resident_yes" name='c1_uk_resident' checked={getFormValueWithId(ifid, "c1_uk_resident") === '1'} onChange={(e) => doFormOnChange(e)} />
													</div>
													<div className='flexGrow1'>
														<label htmlFor="c1_uk_resident_yes">Yes</label>
													</div>
												</div>
												<div className='row33' style={{ display: 'flex', alignItems: 'center' }}>
													<div style={{ padding: 8 }}>
														<input data-form-id={ifid} className={getFormValidWithId(ifid, "c1_uk_resident") ? undefined : 'error'} disabled={isInstructed} type='radio' value='2' id="c1_uk_resident_no" name='c1_uk_resident' checked={getFormValueWithId(ifid, "c1_uk_resident") === '2'} onChange={(e) => doFormOnChange(e)} />
													</div>
													<div className='flexGrow1'>
														<label htmlFor="c1_uk_resident_no">No</label>
													</div>
												</div>
											</div>
										</div>

										<div style={{ display: 'flex', margin: 4 }}>
											<div className='row50' style={{ fontFamily: 'OpenSans-Bold' }}>Client 1 Home Address</div>
											<div className='row50'>
												<div style={{ display: 'flex', alignItems: 'center' }}>
													<div style={{ padding: 8 }}>
														<input data-form-id={ifid} disabled={isInstructed} type="checkbox" checked={getFormValueWithId(ifid, "c1_ind_addr_pop") === 'true'} name="c1_ind_addr_pop" id="c1_ind_addr_pop" onChange={(e) => doFormOnChange(e)} />
													</div>
													<div>
														<label htmlFor='c1_ind_addr_pop'>Use Property Address</label>
													</div>
												</div>
											</div>
										</div>

										{(getFormValueWithId(ifid, "c1_ind_addr_pop") === 'false' || getFormValueWithId(ifid, "c1_ind_addr_pop") === '') &&
											<div>
												<div style={{ display: 'flex', margin: 4 }}>
													<div className='row50'>
														<label htmlFor='c1_home_address_house'>House No./Name:</label>
													</div>
													<div className='row50'>
														<input data-form-id={ifid} data-valid-type="*" className={getFormValidWithId(ifid, "c1_home_address_house") ? undefined : 'error'} disabled={isInstructed} type='text' value={getFormValueWithId(ifid, "c1_home_address_house")} name='c1_home_address_house' id='c1_home_address_house' onChange={(e) => doFormOnChange(e)} />
													</div>
												</div>

												<div style={{ display: 'flex', margin: 4 }}>
													<div className='row50'>
														<label htmlFor='c1_home_address_street'>Street:</label>
													</div>
													<div className='row50'>
														<input data-form-id={ifid} data-valid-type="*" className={getFormValidWithId(ifid, "c1_home_address_street") ? undefined : 'error'} disabled={isInstructed} type='text' value={getFormValueWithId(ifid, "c1_home_address_street")} name='c1_home_address_street' id='c1_home_address_street' onChange={(e) => doFormOnChange(e)} />
													</div>
												</div>

												<div style={{ display: 'flex', margin: 4 }}>
													<div className='row50'>
														<label htmlFor='c1_home_address_town'>Town:</label>
													</div>
													<div className='row50'>
														<input data-form-id={ifid} data-valid-type="*" className={getFormValidWithId(ifid, "c1_home_address_town") ? undefined : 'error'} disabled={isInstructed} type='text' value={getFormValueWithId(ifid, "c1_home_address_town")} name='c1_home_address_town' id='c1_home_address_town' onChange={(e) => doFormOnChange(e)} />
													</div>
												</div>

												<div style={{ display: 'flex', margin: 4 }}>
													<div className='row50'>
														<label htmlFor='c1_home_address_county'>County:</label>
													</div>
													<div className='row50'>
														<input data-form-id={ifid} disabled={isInstructed} type='text' value={getFormValueWithId(ifid, "c1_home_address_county")} name='c1_home_address_county' id='c1_home_address_county' onChange={(e) => doFormOnChange(e)} />
													</div>
												</div>

												<div style={{ display: 'flex', margin: 4 }}>
													<div className='row50'>
														<label htmlFor='c1_home_address_postcode'>Postcode:</label>
													</div>
													<div className='row50'>
														<input data-form-id={ifid} data-valid-type="*" className={getFormValidWithId(ifid, "c1_home_address_postcode") ? undefined : 'error'} disabled={isInstructed} type='text' value={getFormValueWithId(ifid, "c1_home_address_postcode")} name='c1_home_address_postcode' id='c1_home_address_postcode' onChange={(e) => doFormOnChange(e)} />
													</div>
												</div>

												<div style={{ display: 'flex', margin: 4 }}>
													<div className='row50'></div>
													<div className='row50'>
														<div className='buttonGreen' style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', overflow: 'hidden', flex: '1 1 0px' }} onClick={() => getPostcodeAddresses(ifid, 'c1_home_address')}>
															<div style={{ display: 'flex' }}>
																<FontAwesomeIcon style={{ fontSize: 18, marginRight: 8 }} icon={faMagnifyingGlassLocation} />
																<div style={{ whiteSpace: 'nowrap', textOverflow: 'ellipsis', overflow: 'hidden' }}>Find Postcode</div>
															</div>
															{forms.isGettingAddress['c1_home_address'] &&
																<FontAwesomeIcon className='fa-spin' style={{ fontSize: 18, marginRight: 8 }} icon={faSync} />
															}
														</div>
													</div>
												</div>

												{getAddressListWithId('c1_home_address').length > 0 &&
													<div style={{ display: 'flex', margin: 4 }}>
														<div className='row50'>Select Address:</div>
														<div className='row50'>
															<select data-form-id={ifid} value={getFormValueWithId(ifid, "c1_home_address")} name='c1_home_address' onChange={(e) => selectAddress(e)}>
																<option value=''>Please Select...</option>
																{getAddressListWithId('c1_home_address').map((item: Forms.postcodeAddressState, index: number) => {
																	return (
																		<option key={index} value={index}> {item.premise}, {item.street}, {item.posttown}, {item.county}.</option>
																	)
																})}
															</select>
														</div>
													</div>
												}
											</div>
										}
									</div>
								}

								{getFormValueWithId(ifid, "c1_comp_or_ind") === "1" &&
									<div>
										<div style={{ fontFamily: 'OpenSans-Bold', margin: 4 }}>Company Details</div>

										<div style={{ display: 'flex', margin: 4 }}>
											<div className='row50'>
												<label htmlFor='c1_company_name'>Company Full Name:</label>
											</div>
											<div className='row50'>
												<input data-form-id={ifid} data-valid-type="*" className={getFormValidWithId(ifid, "c1_company_name") ? undefined : 'error'} disabled={isInstructed} type='text' value={getFormValueWithId(ifid, "c1_company_name")} name='c1_company_name' id='c1_company_name' onChange={(e) => doFormOnChange(e)} />
											</div>
										</div>

										<div style={{ display: 'flex', margin: 4 }}>
											<div className='row50'>
												<label htmlFor='c1_company_number'>Company Number:</label>
											</div>
											<div className='row50'>
												<input data-form-id={ifid} data-valid-type="*" className={getFormValidWithId(ifid, "c1_company_number") ? undefined : 'error'} disabled={isInstructed} type='text' value={getFormValueWithId(ifid, "c1_company_number")} name='c1_company_number' id='c1_company_number' onChange={(e) => doFormOnChange(e)} />
											</div>
										</div>

										<div style={{ display: 'flex', margin: 4 }}>
											<div className='row50'>
												<label htmlFor='c1_contact1_name'>Contact Name:</label>
											</div>
											<div className='row50'>
												<input data-form-id={ifid} data-valid-type="*" className={getFormValidWithId(ifid, "c1_contact1_name") ? undefined : 'error'} disabled={isInstructed} type='text' value={getFormValueWithId(ifid, "c1_contact1_name")} name='c1_contact1_name' id='c1_contact1_name' onChange={(e) => doFormOnChange(e)} />
											</div>
										</div>

										<div style={{ display: 'flex', margin: 4 }}>
											<div className='row50'>
												<label htmlFor='c1_contact1_email'>Contact Email Address:</label>
											</div>
											<div className='row50'>
												<input data-form-id={ifid} data-valid-type="email" className={getFormValidWithId(ifid, "c1_contact1_email") ? undefined : 'error'} disabled={isInstructed} type='text' value={getFormValueWithId(ifid, "c1_contact1_email")} name='c1_contact1_email' id='c1_contact1_email' onChange={(e) => doFormOnChange(e)} />
											</div>
										</div>

										<div style={{ display: 'flex', margin: 4 }}>
											<div className='row50'>
												<label htmlFor='c1_contact1_mobile'>Contact Mobile Phone No:</label>
											</div>
											<div className='row50'>
												<input data-form-id={ifid} data-valid-type="*" className={getFormValidWithId(ifid, "c1_contact1_mobile") ? undefined : 'error'} disabled={isInstructed} type='text' value={getFormValueWithId(ifid, "c1_contact1_mobile")} name='c1_contact1_mobile' id='c1_contact1_mobile' onChange={(e) => doFormOnChange(e)} />
											</div>
										</div>

										<div style={{ fontFamily: 'OpenSans-Bold', margin: 4 }}>Registered Office Address</div>

										<div style={{ display: 'flex', margin: 4 }}>
											<div className='row50'>
												<label htmlFor='c1_company_property'>Property No./Name:</label>
											</div>
											<div className='row50'>
												<input data-form-id={ifid} data-valid-type="*" className={getFormValidWithId(ifid, "c1_company_property") ? undefined : 'error'} disabled={isInstructed} type='text' value={getFormValueWithId(ifid, "c1_company_property")} name='c1_company_property' id='c1_company_property' onChange={(e) => doFormOnChange(e)} />
											</div>
										</div>

										<div style={{ display: 'flex', margin: 4 }}>
											<div className='row50'>
												<label htmlFor='c1_company_street'>Street:</label>
											</div>
											<div className='row50'>
												<input data-form-id={ifid} data-valid-type="*" className={getFormValidWithId(ifid, "c1_company_street") ? undefined : 'error'} disabled={isInstructed} type='text' value={getFormValueWithId(ifid, "c1_company_street")} name='c1_company_street' id='c1_company_street' onChange={(e) => doFormOnChange(e)} />
											</div>
										</div>

										<div style={{ display: 'flex', margin: 4 }}>
											<div className='row50'>
												<label htmlFor='c1_company_town'>Town:</label>
											</div>
											<div className='row50'>
												<input data-form-id={ifid} data-valid-type="*" className={getFormValidWithId(ifid, "c1_company_town") ? undefined : 'error'} disabled={isInstructed} type='text' value={getFormValueWithId(ifid, "c1_company_town")} name='c1_company_town' id='c1_company_town' onChange={(e) => doFormOnChange(e)} />
											</div>
										</div>

										<div style={{ display: 'flex', margin: 4 }}>
											<div className='row50'>
												<label htmlFor='c1_company_county'>County:</label>
											</div>
											<div className='row50'>
												<input data-form-id={ifid} disabled={isInstructed} type='text' value={getFormValueWithId(ifid, "c1_company_county")} name='c1_company_county' id='c1_company_county' onChange={(e) => doFormOnChange(e)} />
											</div>
										</div>

										<div style={{ display: 'flex', margin: 4 }}>
											<div className='row50'>
												<label htmlFor='c1_company_postcode'>Postcode:</label>
											</div>
											<div className='row50'>
												<input data-form-id={ifid} data-valid-type="*" className={getFormValidWithId(ifid, "c1_company_postcode") ? undefined : 'error'} disabled={isInstructed} type='text' value={getFormValueWithId(ifid, "c1_company_postcode")} name='c1_company_postcode' id='c1_company_postcode' onChange={(e) => doFormOnChange(e)} />
											</div>
										</div>

										<div style={{ display: 'flex', margin: 4 }}>
											<div className='row50'></div>
											<div className='row50'>
												<div className='buttonGreen' style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', overflow: 'hidden', flex: '1 1 0px' }} onClick={() => getPostcodeAddresses(ifid, 'c1_company')}>
													<div style={{ display: 'flex' }}>
														<FontAwesomeIcon style={{ fontSize: 18, marginRight: 8 }} icon={faMagnifyingGlassLocation} />
														<div style={{ whiteSpace: 'nowrap', textOverflow: 'ellipsis', overflow: 'hidden' }}>Find Postcode</div>
													</div>
													{forms.isGettingAddress['c1_company'] &&
														<FontAwesomeIcon className='fa-spin' style={{ fontSize: 18, marginRight: 8 }} icon={faSync} />
													}
												</div>
											</div>
										</div>

										{getAddressListWithId('c1_company').length > 0 &&
											<div style={{ display: 'flex', margin: 4 }}>
												<div className='row50'>Select Address:</div>
												<div className='row50'>
													<select data-form-id={ifid} value={getFormValueWithId(ifid, "c1_company")} name='c1_company' onChange={(e) => selectAddress(e)}>
														<option value=''>Please Select...</option>
														{getAddressListWithId('c1_company').map((item: Forms.postcodeAddressState, index: number) => {
															return (
																<option key={index} value={index}> {item.premise}, {item.street}, {item.posttown}, {item.county}.</option>
															)
														})}
													</select>
												</div>
											</div>
										}

										<div style={{ display: 'flex', margin: 4 }}>
											<div className='row50'>Is this company Registered in the UK?</div>
											<div className='row50' style={{ display: 'flex', alignItems: 'center' }}>
												<div className='row33' style={{ display: 'flex', alignItems: 'center' }}>
													<div style={{ padding: 8 }}>
														<input data-form-id={ifid} className={getFormValidWithId(ifid, "c1_uk_registered") ? undefined : 'error'} disabled={isInstructed} type='radio' value='1' id="c1_uk_registered_yes" name='c1_uk_registered' checked={getFormValueWithId(ifid, "c1_uk_registered") === '1'} onChange={(e) => doFormOnChange(e)} />
													</div>
													<div className='flexGrow1'>
														<label htmlFor="c1_uk_registered_yes">Yes</label>
													</div>
												</div>
												<div className='row33' style={{ display: 'flex', alignItems: 'center' }}>
													<div style={{ padding: 8 }}>
														<input data-form-id={ifid} className={getFormValidWithId(ifid, "c1_uk_registered") ? undefined : 'error'} disabled={isInstructed} type='radio' value='2' id="c1_uk_registered_no" name='c1_uk_registered' checked={getFormValueWithId(ifid, "c1_uk_registered") === '2'} onChange={(e) => doFormOnChange(e)} />
													</div>
													<div className='flexGrow1'>
														<label htmlFor="c1_uk_registered_no">No</label>
													</div>
												</div>
											</div>
										</div>
									</div>
								}

								{parseInt(getFormValueWithId(qfid, "quote_nclients")) > 1 &&
									<div>
										<div className="main_rule"></div>
										<div style={{ fontFamily: 'OpenSans-Bold', margin: 4 }}>Remortgager 2 Details</div>

										<div style={{ display: 'flex', margin: 4 }}>
											<div className='row50'>Is this a Company or an Individual?</div>
											<div className='row50'>
												<select data-form-id={ifid} data-valid-type="*" className={getFormValidWithId(ifid, "c2_comp_or_ind") ? undefined : 'error'} disabled={isInstructed} value={getFormValueWithId(ifid, "c2_comp_or_ind")} name='c2_comp_or_ind' onChange={(e) => doFormOnChange(e)}>
													<option value=''>Please Select...</option>
													<option value='0'>Individual</option>
													<option value='1'>Company</option>
												</select>
											</div>
										</div>

										{getFormValueWithId(ifid, "c2_comp_or_ind") === "0" &&
											<div>
												<div style={{ fontFamily: 'OpenSans-Bold', margin: 4 }}>Client 2 Details</div>

												<div style={{ display: 'flex', margin: 4 }}>
													<div className='row50'>Title:</div>
													<div className='row50'>
														<select data-form-id={ifid} data-valid-type="*" className={getFormValidWithId(ifid, "c2_title") ? undefined : 'error'} disabled={isInstructed} value={getFormValueWithId(ifid, "c2_title")} name='c2_title' onChange={(e) => doFormOnChange(e)}>
															<option value=''>Please Select...</option>
															<option value='Miss'>Miss</option>
															<option value='Ms'>Ms</option>
															<option value='Mrs'>Mrs</option>
															<option value='Mr'>Mr</option>
															<option value='Dr'>Dr</option>
															<option value='Other'>Other</option>
														</select>
													</div>
												</div>

												{getFormValueWithId(ifid, "c2_title") === "Other" &&
													<div style={{ display: 'flex', margin: 4 }}>
														<div className='row50'>
															<label htmlFor='c2_title_specify'>Please Specify:</label>
														</div>
														<div className='row50'>
															<input data-form-id={ifid} data-valid-type="*" className={getFormValidWithId(ifid, "c2_title_specify") ? undefined : 'error'} disabled={isInstructed} type='text' value={getFormValueWithId(ifid, "c2_title_specify")} name='c2_title_specify' id='c2_title_specify' onChange={(e) => doFormOnChange(e)} />
														</div>
													</div>
												}

												<div style={{ display: 'flex', margin: 4 }}>
													<div className='row50'>
														<label htmlFor='c2_firstname'>First Name:</label>
													</div>
													<div className='row50'>
														<input data-form-id={ifid} data-valid-type="*" className={getFormValidWithId(ifid, "c2_firstname") ? undefined : 'error'} disabled={isInstructed} type='text' value={getFormValueWithId(ifid, "c2_firstname")} name='c2_firstname' id='c2_firstname' onChange={(e) => doFormOnChange(e)} />
													</div>
												</div>

												<div style={{ display: 'flex', margin: 4 }}>
													<div className='row50'>
														<label htmlFor='c2_middlenames'>Middle Names:</label>
													</div>
													<div className='row50'>
														<input data-form-id={ifid} disabled={isInstructed} type='text' value={getFormValueWithId(ifid, "c2_middlenames")} name='c2_middlenames' id='c2_middlenames' onChange={(e) => doFormOnChange(e)} />
													</div>
												</div>

												<div style={{ display: 'flex', margin: 4 }}>
													<div className='row50'>
														<label htmlFor='c2_surname'>Surname:</label>
													</div>
													<div className='row50'>
														<input data-form-id={ifid} data-valid-type="*" className={getFormValidWithId(ifid, "c2_surname") ? undefined : 'error'} disabled={isInstructed} type='text' value={getFormValueWithId(ifid, "c2_surname")} name='c2_surname' id='c2_surname' onChange={(e) => doFormOnChange(e)} />
													</div>
												</div>

												<div style={{ display: 'flex', margin: 4 }}>
													<div className='row50'>
														<label htmlFor='c2_email'>Email Address:</label>
													</div>
													<div className='row50' style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', gap: '3px'}}>
														<input data-form-id={ifid} data-valid-type="email" data-valid-message='Please enter a valid Email address' data-valid-unique='["c1_email"]' data-unique-message='Email address must be unique to this Client' className={getFormValidWithId(ifid, "c2_email") ? undefined : 'error'} disabled={isInstructed} type='text' value={getFormValueWithId(ifid, "c2_email")} name='c2_email' id='c2_email' onChange={(e) => doFormOnChange(e)} />
														{!getFormValidWithId(ifid, 'c2_email') &&
															<div style={{ color: 'red', fontSize: '14px' }}>{getFormMessageWithId(ifid, 'c2_email')}</div>
														}
													</div>
												</div>

												<div style={{ display: 'flex', margin: 4 }}>
													<div className='row50'>
														<label htmlFor='c2_main_number'>Home Phone No:</label>
													</div>
													<div className='row50'>
														<input data-form-id={ifid} disabled={isInstructed} type='text' value={getFormValueWithId(ifid, "c2_main_number")} name='c2_main_number' id='c2_main_number' onChange={(e) => doFormOnChange(e)} />
													</div>
												</div>

												<div style={{ display: 'flex', margin: 4 }}>
													<div className='row50'>
														<label htmlFor='c2_mobile_number'>Mobile Phone No:</label>
													</div>
													<div className='row50'>
														<input data-form-id={ifid} data-valid-type="*" data-valid-unique='["c1_mobile_number"]' data-unique-message='Mobile number must be unique to this Client' className={getFormValidWithId(ifid, "c2_mobile_number") ? undefined : 'error'} disabled={isInstructed} type='text' value={getFormValueWithId(ifid, "c2_mobile_number")} name='c2_mobile_number' id='c2_mobile_number' onChange={(e) => doFormOnChange(e)} />
														{!getFormValidWithId(ifid, 'c2_mobile_number') &&
															<div style={{ color: 'red', fontSize: '14px' }}>{getFormMessageWithId(ifid, 'c2_mobile_number')}</div>
														}
													</div>
												</div>

												<div style={{ display: 'flex', margin: 4 }}>
													<div className='row50'>
														<div style={{ display: 'flex', flexDirection: 'column' }}>
															<div>Is Client 2 a UK Resident?</div>
															<div style={{ fontSize: 12 }}>For more information please click <a href="https://www.gov.uk/government/publications/rdr3-statutory-residence-test-srt" target="_blank">here</a></div>
														</div>
													</div>
													<div className='row50' style={{ display: 'flex', alignItems: 'center' }}>
														<div className='row33' style={{ display: 'flex', alignItems: 'center' }}>
															<div style={{ padding: 8 }}>
																<input data-form-id={ifid} className={getFormValidWithId(ifid, "c2_uk_resident") ? undefined : 'error'} disabled={isInstructed} type='radio' value='1' id="c2_uk_resident_yes" name='c2_uk_resident' checked={getFormValueWithId(ifid, "c2_uk_resident") === '1'} onChange={(e) => doFormOnChange(e)} />
															</div>
															<div className='flexGrow1'>
																<label htmlFor="c2_uk_resident_yes">Yes</label>
															</div>
														</div>
														<div className='row33' style={{ display: 'flex', alignItems: 'center' }}>
															<div style={{ padding: 8 }}>
																<input data-form-id={ifid} className={getFormValidWithId(ifid, "c2_uk_resident") ? undefined : 'error'} disabled={isInstructed} type='radio' value='2' id="c2_uk_resident_no" name='c2_uk_resident' checked={getFormValueWithId(ifid, "c2_uk_resident") === '2'} onChange={(e) => doFormOnChange(e)} />
															</div>
															<div className='flexGrow1'>
																<label htmlFor="c2_uk_resident_no">No</label>
															</div>
														</div>
													</div>
												</div>

												<div style={{ display: 'flex', margin: 4 }}>
													<div className='row50' style={{ fontFamily: 'OpenSans-Bold' }}>Client 2 Home Address</div>
													<div className='row50'>
														<div style={{ display: 'flex', alignItems: 'center' }}>
															<div style={{ padding: 8 }}>
																<input data-form-id={ifid} disabled={isInstructed} type="checkbox" checked={getFormValueWithId(ifid, "c2_ind_addr_pop") === 'true'} name="c2_ind_addr_pop" id="c2_ind_addr_pop" onChange={(e) => doFormOnChange(e)} />
															</div>
															<div>
																<label htmlFor='c2_ind_addr_pop'>Use Property Address</label>
															</div>
														</div>
													</div>
												</div>

												{(getFormValueWithId(ifid, "c2_ind_addr_pop") === 'false' || getFormValueWithId(ifid, "c2_ind_addr_pop") === '') &&
													<div>
														<div style={{ display: 'flex', margin: 4 }}>
															<div className='row50'>
																<label htmlFor='c2_home_address_house'>House No./Name:</label>
															</div>
															<div className='row50'>
																<input data-form-id={ifid} data-valid-type="*" className={getFormValidWithId(ifid, "c2_home_address_house") ? undefined : 'error'} disabled={isInstructed} type='text' value={getFormValueWithId(ifid, "c2_home_address_house")} name='c2_home_address_house' id='c2_home_address_house' onChange={(e) => doFormOnChange(e)} />
															</div>
														</div>

														<div style={{ display: 'flex', margin: 4 }}>
															<div className='row50'>
																<label htmlFor='c2_home_address_street'>Street:</label>
															</div>
															<div className='row50'>
																<input data-form-id={ifid} data-valid-type="*" className={getFormValidWithId(ifid, "c2_home_address_street") ? undefined : 'error'} disabled={isInstructed} type='text' value={getFormValueWithId(ifid, "c2_home_address_street")} name='c2_home_address_street' id='c2_home_address_street' onChange={(e) => doFormOnChange(e)} />
															</div>
														</div>

														<div style={{ display: 'flex', margin: 4 }}>
															<div className='row50'>
																<label htmlFor='c2_home_address_town'>Town:</label>
															</div>
															<div className='row50'>
																<input data-form-id={ifid} data-valid-type="*" className={getFormValidWithId(ifid, "c2_home_address_town") ? undefined : 'error'} disabled={isInstructed} type='text' value={getFormValueWithId(ifid, "c2_home_address_town")} name='c2_home_address_town' id='c2_home_address_town' onChange={(e) => doFormOnChange(e)} />
															</div>
														</div>

														<div style={{ display: 'flex', margin: 4 }}>
															<div className='row50'>
																<label htmlFor='c2_home_address_county'>County:</label>
															</div>
															<div className='row50'>
																<input data-form-id={ifid} disabled={isInstructed} type='text' value={getFormValueWithId(ifid, "c2_home_address_county")} name='c2_home_address_county' id='c2_home_address_county' onChange={(e) => doFormOnChange(e)} />
															</div>
														</div>

														<div style={{ display: 'flex', margin: 4 }}>
															<div className='row50'>
																<label htmlFor='c2_home_address_postcode'>Postcode:</label>
															</div>
															<div className='row50'>
																<input data-form-id={ifid} data-valid-type="*" className={getFormValidWithId(ifid, "c2_home_address_postcode") ? undefined : 'error'} disabled={isInstructed} type='text' value={getFormValueWithId(ifid, "c2_home_address_postcode")} name='c2_home_address_postcode' id='c2_home_address_postcode' onChange={(e) => doFormOnChange(e)} />
															</div>
														</div>

														<div style={{ display: 'flex', margin: 4 }}>
															<div className='row50'></div>
															<div className='row50'>
																<div className='buttonGreen' style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', overflow: 'hidden', flex: '1 1 0px' }} onClick={() => getPostcodeAddresses(ifid, 'c2_home_address')}>
																	<div style={{ display: 'flex' }}>
																		<FontAwesomeIcon style={{ fontSize: 18, marginRight: 8 }} icon={faMagnifyingGlassLocation} />
																		<div style={{ whiteSpace: 'nowrap', textOverflow: 'ellipsis', overflow: 'hidden' }}>Find Postcode</div>
																	</div>
																	{forms.isGettingAddress['c2_home_address'] &&
																		<FontAwesomeIcon className='fa-spin' style={{ fontSize: 18, marginRight: 8 }} icon={faSync} />
																	}
																</div>
															</div>
														</div>

														{getAddressListWithId('c2_home_address').length > 0 &&
															<div style={{ display: 'flex', margin: 4 }}>
																<div className='row50'>Select Address:</div>
																<div className='row50'>
																	<select data-form-id={ifid} value={getFormValueWithId(ifid, "c2_home_address")} name='c2_home_address' onChange={(e) => selectAddress(e)}>
																		<option value=''>Please Select...</option>
																		{getAddressListWithId('c2_home_address').map((item: Forms.postcodeAddressState, index: number) => {
																			return (
																				<option key={index} value={index}> {item.premise}, {item.street}, {item.posttown}, {item.county}.</option>
																			)
																		})}
																	</select>
																</div>
															</div>
														}
													</div>
												}
											</div>
										}

										{getFormValueWithId(ifid, "c2_comp_or_ind") === "1" &&
											<div>
												<div style={{ fontFamily: 'OpenSans-Bold', margin: 4 }}>Company Details</div>

												<div style={{ display: 'flex', margin: 4 }}>
													<div className='row50'>
														<label htmlFor='c2_company_name'>Company Full Name:</label>
													</div>
													<div className='row50'>
														<input data-form-id={ifid} data-valid-type="*" className={getFormValidWithId(ifid, "c2_company_name") ? undefined : 'error'} disabled={isInstructed} type='text' value={getFormValueWithId(ifid, "c2_company_name")} name='c2_company_name' id='c2_company_name' onChange={(e) => doFormOnChange(e)} />
													</div>
												</div>

												<div style={{ display: 'flex', margin: 4 }}>
													<div className='row50'>
														<label htmlFor='c2_company_number'>Company Number:</label>
													</div>
													<div className='row50'>
														<input data-form-id={ifid} data-valid-type="*" className={getFormValidWithId(ifid, "c2_company_number") ? undefined : 'error'} disabled={isInstructed} type='text' value={getFormValueWithId(ifid, "c2_company_number")} name='c2_company_number' id='c2_company_number' onChange={(e) => doFormOnChange(e)} />
													</div>
												</div>

												<div style={{ display: 'flex', margin: 4 }}>
													<div className='row50'>
														<label htmlFor='c2_contact1_name'>Contact Name:</label>
													</div>
													<div className='row50'>
														<input data-form-id={ifid} data-valid-type="*" className={getFormValidWithId(ifid, "c2_contact1_name") ? undefined : 'error'} disabled={isInstructed} type='text' value={getFormValueWithId(ifid, "c2_contact1_name")} name='c2_contact1_name' id='c2_contact1_name' onChange={(e) => doFormOnChange(e)} />
													</div>
												</div>

												<div style={{ display: 'flex', margin: 4 }}>
													<div className='row50'>
														<label htmlFor='c2_contact1_email'>Contact Email Address:</label>
													</div>
													<div className='row50'>
														<input data-form-id={ifid} data-valid-type="email" className={getFormValidWithId(ifid, "c2_contact1_email") ? undefined : 'error'} disabled={isInstructed} type='text' value={getFormValueWithId(ifid, "c2_contact1_email")} name='c2_contact1_email' id='c2_contact1_email' onChange={(e) => doFormOnChange(e)} />
													</div>
												</div>

												<div style={{ display: 'flex', margin: 4 }}>
													<div className='row50'>
														<label htmlFor='c2_contact1_mobile'>Contact Mobile Phone No:</label>
													</div>
													<div className='row50'>
														<input data-form-id={ifid} data-valid-type="*" className={getFormValidWithId(ifid, "c2_contact1_mobile") ? undefined : 'error'} disabled={isInstructed} type='text' value={getFormValueWithId(ifid, "c2_contact1_mobile")} name='c2_contact1_mobile' id='c2_contact1_mobile' onChange={(e) => doFormOnChange(e)} />
													</div>
												</div>

												<div style={{ fontFamily: 'OpenSans-Bold', margin: 4 }}>Registered Office Address</div>

												<div style={{ display: 'flex', margin: 4 }}>
													<div className='row50'>
														<label htmlFor='c2_company_property'>Property No./Name:</label>
													</div>
													<div className='row50'>
														<input data-form-id={ifid} data-valid-type="*" className={getFormValidWithId(ifid, "c2_company_property") ? undefined : 'error'} disabled={isInstructed} type='text' value={getFormValueWithId(ifid, "c2_company_property")} name='c2_company_property' id='c2_company_property' onChange={(e) => doFormOnChange(e)} />
													</div>
												</div>

												<div style={{ display: 'flex', margin: 4 }}>
													<div className='row50'>
														<label htmlFor='c2_company_street'>Street:</label>
													</div>
													<div className='row50'>
														<input data-form-id={ifid} data-valid-type="*" className={getFormValidWithId(ifid, "c2_company_street") ? undefined : 'error'} disabled={isInstructed} type='text' value={getFormValueWithId(ifid, "c2_company_street")} name='c2_company_street' id='c2_company_street' onChange={(e) => doFormOnChange(e)} />
													</div>
												</div>

												<div style={{ display: 'flex', margin: 4 }}>
													<div className='row50'>
														<label htmlFor='c2_company_town'>Town:</label>
													</div>
													<div className='row50'>
														<input data-form-id={ifid} data-valid-type="*" className={getFormValidWithId(ifid, "c2_company_town") ? undefined : 'error'} disabled={isInstructed} type='text' value={getFormValueWithId(ifid, "c2_company_town")} name='c2_company_town' id='c2_company_town' onChange={(e) => doFormOnChange(e)} />
													</div>
												</div>

												<div style={{ display: 'flex', margin: 4 }}>
													<div className='row50'>
														<label htmlFor='c2_company_county'>County:</label>
													</div>
													<div className='row50'>
														<input data-form-id={ifid} disabled={isInstructed} type='text' value={getFormValueWithId(ifid, "c2_company_county")} name='c2_company_county' id='c2_company_county' onChange={(e) => doFormOnChange(e)} />
													</div>
												</div>

												<div style={{ display: 'flex', margin: 4 }}>
													<div className='row50'>
														<label htmlFor='c2_company_postcode'>Postcode:</label>
													</div>
													<div className='row50'>
														<input data-form-id={ifid} data-valid-type="*" className={getFormValidWithId(ifid, "c2_company_postcode") ? undefined : 'error'} disabled={isInstructed} type='text' value={getFormValueWithId(ifid, "c2_company_postcode")} name='c2_company_postcode' id='c2_company_postcode' onChange={(e) => doFormOnChange(e)} />
													</div>
												</div>

												<div style={{ display: 'flex', margin: 4 }}>
													<div className='row50'></div>
													<div className='row50'>
														<div className='buttonGreen' style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', overflow: 'hidden', flex: '1 1 0px' }} onClick={() => getPostcodeAddresses(ifid, 'c2_company')}>
															<div style={{ display: 'flex' }}>
																<FontAwesomeIcon style={{ fontSize: 18, marginRight: 8 }} icon={faMagnifyingGlassLocation} />
																<div style={{ whiteSpace: 'nowrap', textOverflow: 'ellipsis', overflow: 'hidden' }}>Find Postcode</div>
															</div>
															{forms.isGettingAddress['c2_company'] &&
																<FontAwesomeIcon className='fa-spin' style={{ fontSize: 18, marginRight: 8 }} icon={faSync} />
															}
														</div>
													</div>
												</div>

												{getAddressListWithId('c2_company').length > 0 &&
													<div style={{ display: 'flex', margin: 4 }}>
														<div className='row50'>Select Address:</div>
														<div className='row50'>
															<select data-form-id={ifid} value={getFormValueWithId(ifid, "c2_company")} name='c2_company' onChange={(e) => selectAddress(e)}>
																<option value=''>Please Select...</option>
																{getAddressListWithId('c2_company').map((item: Forms.postcodeAddressState, index: number) => {
																	return (
																		<option key={index} value={index}> {item.premise}, {item.street}, {item.posttown}, {item.county}.</option>
																	)
																})}
															</select>
														</div>
													</div>
												}

												<div style={{ display: 'flex', margin: 4 }}>
													<div className='row50'>Is this company Registered in the UK?</div>
													<div className='row50' style={{ display: 'flex', alignItems: 'center' }}>
														<div className='row33' style={{ display: 'flex', alignItems: 'center' }}>
															<div style={{ padding: 8 }}>
																<input data-form-id={ifid} className={getFormValidWithId(ifid, "c2_uk_registered") ? undefined : 'error'} disabled={isInstructed} type='radio' value='1' id="c2_uk_registered_yes" name='c2_uk_registered' checked={getFormValueWithId(ifid, "c2_uk_registered") === '1'} onChange={(e) => doFormOnChange(e)} />
															</div>
															<div className='flexGrow1'>
																<label htmlFor="c2_uk_registered_yes">Yes</label>
															</div>
														</div>
														<div className='row33' style={{ display: 'flex', alignItems: 'center' }}>
															<div style={{ padding: 8 }}>
																<input data-form-id={ifid} className={getFormValidWithId(ifid, "c2_uk_registered") ? undefined : 'error'} disabled={isInstructed} type='radio' value='2' id="c2_uk_registered_no" name='c2_uk_registered' checked={getFormValueWithId(ifid, "c2_uk_registered") === '2'} onChange={(e) => doFormOnChange(e)} />
															</div>
															<div className='flexGrow1'>
																<label htmlFor="c2_uk_registered_no">No</label>
															</div>
														</div>
													</div>
												</div>
											</div>
										}
									</div>
								}

								{parseInt(getFormValueWithId(qfid, "quote_nclients")) > 2 &&
									<div>
										<div className="main_rule"></div>
										<div style={{ fontFamily: 'OpenSans-Bold', margin: 4 }}>Remortgager 3 Details</div>

										<div style={{ display: 'flex', margin: 4 }}>
											<div className='row50'>Is this a Company or an Individual?</div>
											<div className='row50'>
												<select data-form-id={ifid} data-valid-type="*" className={getFormValidWithId(ifid, "c3_comp_or_ind") ? undefined : 'error'} disabled={isInstructed} value={getFormValueWithId(ifid, "c3_comp_or_ind")} name='c3_comp_or_ind' onChange={(e) => doFormOnChange(e)}>
													<option value=''>Please Select...</option>
													<option value='0'>Individual</option>
													<option value='1'>Company</option>
												</select>
											</div>
										</div>

										{getFormValueWithId(ifid, "c3_comp_or_ind") === "0" &&
											<div>
												<div style={{ fontFamily: 'OpenSans-Bold', margin: 4 }}>Client 3 Details</div>

												<div style={{ display: 'flex', margin: 4 }}>
													<div className='row50'>Title:</div>
													<div className='row50'>
														<select data-form-id={ifid} data-valid-type="*" className={getFormValidWithId(ifid, "c3_title") ? undefined : 'error'} disabled={isInstructed} value={getFormValueWithId(ifid, "c3_title")} name='c3_title' onChange={(e) => doFormOnChange(e)}>
															<option value=''>Please Select...</option>
															<option value='Miss'>Miss</option>
															<option value='Ms'>Ms</option>
															<option value='Mrs'>Mrs</option>
															<option value='Mr'>Mr</option>
															<option value='Dr'>Dr</option>
															<option value='Other'>Other</option>
														</select>
													</div>
												</div>

												{getFormValueWithId(ifid, "c3_title") === "Other" &&
													<div style={{ display: 'flex', margin: 4 }}>
														<div className='row50'>
															<label htmlFor='c3_title_specify'>Please Specify:</label>
														</div>
														<div className='row50'>
															<input data-form-id={ifid} data-valid-type="*" className={getFormValidWithId(ifid, "c3_title_specify") ? undefined : 'error'} disabled={isInstructed} type='text' value={getFormValueWithId(ifid, "c3_title_specify")} name='c3_title_specify' id='c3_title_specify' onChange={(e) => doFormOnChange(e)} />
														</div>
													</div>
												}

												<div style={{ display: 'flex', margin: 4 }}>
													<div className='row50'>
														<label htmlFor='c3_firstname'>First Name:</label>
													</div>
													<div className='row50'>
														<input data-form-id={ifid} data-valid-type="*" className={getFormValidWithId(ifid, "c3_firstname") ? undefined : 'error'} disabled={isInstructed} type='text' value={getFormValueWithId(ifid, "c3_firstname")} name='c3_firstname' id='c3_firstname' onChange={(e) => doFormOnChange(e)} />
													</div>
												</div>

												<div style={{ display: 'flex', margin: 4 }}>
													<div className='row50'>
														<label htmlFor='c3_middlenames'>Middle Names:</label>
													</div>
													<div className='row50'>
														<input data-form-id={ifid} disabled={isInstructed} type='text' value={getFormValueWithId(ifid, "c3_middlenames")} name='c3_middlenames' id='c3_middlenames' onChange={(e) => doFormOnChange(e)} />
													</div>
												</div>

												<div style={{ display: 'flex', margin: 4 }}>
													<div className='row50'>
														<label htmlFor='c3_surname'>Surname:</label>
													</div>
													<div className='row50'>
														<input data-form-id={ifid} data-valid-type="*" className={getFormValidWithId(ifid, "c3_surname") ? undefined : 'error'} disabled={isInstructed} type='text' value={getFormValueWithId(ifid, "c3_surname")} name='c3_surname' id='c3_surname' onChange={(e) => doFormOnChange(e)} />
													</div>
												</div>

												<div style={{ display: 'flex', margin: 4 }}>
													<div className='row50'>
														<label htmlFor='c3_email'>Email Address:</label>
													</div>
													<div className='row50' style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', gap: '3px'}}>
														<input data-form-id={ifid} data-valid-type="email" data-valid-message='Please enter a valid Email address' data-valid-unique='["c1_email","c2_email"]' data-unique-message='Email address must be unique to this Client' className={getFormValidWithId(ifid, "c3_email") ? undefined : 'error'} disabled={isInstructed} type='text' value={getFormValueWithId(ifid, "c3_email")} name='c3_email' id='c3_email' onChange={(e) => doFormOnChange(e)} />
														{!getFormValidWithId(ifid, 'c3_email') &&
															<div style={{ color: 'red', fontSize: '14px' }}>{getFormMessageWithId(ifid, 'c3_email')}</div>
														}
													</div>
												</div>

												<div style={{ display: 'flex', margin: 4 }}>
													<div className='row50'>
														<label htmlFor='c3_main_number'>Home Phone No:</label>
													</div>
													<div className='row50'>
														<input data-form-id={ifid} disabled={isInstructed} type='text' value={getFormValueWithId(ifid, "c3_main_number")} name='c3_main_number' id='c3_main_number' onChange={(e) => doFormOnChange(e)} />
													</div>
												</div>

												<div style={{ display: 'flex', margin: 4 }}>
													<div className='row50'>
														<label htmlFor='c3_mobile_number'>Mobile Phone No:</label>
													</div>
													<div className='row50'>
														<input data-form-id={ifid} data-valid-type="*" data-valid-unique='["c1_mobile_number","c2_mobile_number"]' data-unique-message='Mobile number must be unique to this Client' className={getFormValidWithId(ifid, "c3_mobile_number") ? undefined : 'error'} disabled={isInstructed} type='text' value={getFormValueWithId(ifid, "c3_mobile_number")} name='c3_mobile_number' id='c3_mobile_number' onChange={(e) => doFormOnChange(e)} />
														{!getFormValidWithId(ifid, 'c3_mobile_number') &&
															<div style={{ color: 'red', fontSize: '14px' }}>{getFormMessageWithId(ifid, 'c3_mobile_number')}</div>
														}
													</div>
												</div>

												<div style={{ display: 'flex', margin: 4 }}>
													<div className='row50'>
														<div style={{ display: 'flex', flexDirection: 'column' }}>
															<div>Is Client 3 a UK Resident?</div>
															<div style={{ fontSize: 12 }}>For more information please click <a href="https://www.gov.uk/government/publications/rdr3-statutory-residence-test-srt" target="_blank">here</a></div>
														</div>
													</div>
													<div className='row50' style={{ display: 'flex', alignItems: 'center' }}>
														<div className='row33' style={{ display: 'flex', alignItems: 'center' }}>
															<div style={{ padding: 8 }}>
																<input data-form-id={ifid} className={getFormValidWithId(ifid, "c3_uk_resident") ? undefined : 'error'} disabled={isInstructed} type='radio' value='1' id="c3_uk_resident_yes" name='c3_uk_resident' checked={getFormValueWithId(ifid, "c3_uk_resident") === '1'} onChange={(e) => doFormOnChange(e)} />
															</div>
															<div className='flexGrow1'>
																<label htmlFor="c3_uk_resident_yes">Yes</label>
															</div>
														</div>
														<div className='row33' style={{ display: 'flex', alignItems: 'center' }}>
															<div style={{ padding: 8 }}>
																<input data-form-id={ifid} className={getFormValidWithId(ifid, "c3_uk_resident") ? undefined : 'error'} disabled={isInstructed} type='radio' value='2' id="c3_uk_resident_no" name='c3_uk_resident' checked={getFormValueWithId(ifid, "c3_uk_resident") === '2'} onChange={(e) => doFormOnChange(e)} />
															</div>
															<div className='flexGrow1'>
																<label htmlFor="c3_uk_resident_no">No</label>
															</div>
														</div>
													</div>
												</div>

												<div style={{ display: 'flex', margin: 4 }}>
													<div className='row50' style={{ fontFamily: 'OpenSans-Bold' }}>Client 3 Home Address</div>
													<div className='row50'>
														<div style={{ display: 'flex', alignItems: 'center' }}>
															<div style={{ padding: 8 }}>
																<input data-form-id={ifid} disabled={isInstructed} type="checkbox" checked={getFormValueWithId(ifid, "c3_ind_addr_pop") === 'true'} name="c3_ind_addr_pop" id="c3_ind_addr_pop" onChange={(e) => doFormOnChange(e)} />
															</div>
															<div>
																<label htmlFor='c3_ind_addr_pop'>Use Property Address</label>
															</div>
														</div>
													</div>
												</div>

												{(getFormValueWithId(ifid, "c3_ind_addr_pop") === 'false' || getFormValueWithId(ifid, "c3_ind_addr_pop") === '') &&
													<div>
														<div style={{ display: 'flex', margin: 4 }}>
															<div className='row50'>
																<label htmlFor='c3_home_address_house'>House No./Name:</label>
															</div>
															<div className='row50'>
																<input data-form-id={ifid} data-valid-type="*" className={getFormValidWithId(ifid, "c3_home_address_house") ? undefined : 'error'} disabled={isInstructed} type='text' value={getFormValueWithId(ifid, "c3_home_address_house")} name='c3_home_address_house' id='c3_home_address_house' onChange={(e) => doFormOnChange(e)} />
															</div>
														</div>

														<div style={{ display: 'flex', margin: 4 }}>
															<div className='row50'>
																<label htmlFor='c3_home_address_street'>Street:</label>
															</div>
															<div className='row50'>
																<input data-form-id={ifid} data-valid-type="*" className={getFormValidWithId(ifid, "c3_home_address_street") ? undefined : 'error'} disabled={isInstructed} type='text' value={getFormValueWithId(ifid, "c3_home_address_street")} name='c3_home_address_street' id='c3_home_address_street' onChange={(e) => doFormOnChange(e)} />
															</div>
														</div>

														<div style={{ display: 'flex', margin: 4 }}>
															<div className='row50'>
																<label htmlFor='c3_home_address_town'>Town:</label>
															</div>
															<div className='row50'>
																<input data-form-id={ifid} data-valid-type="*" className={getFormValidWithId(ifid, "c3_home_address_town") ? undefined : 'error'} disabled={isInstructed} type='text' value={getFormValueWithId(ifid, "c3_home_address_town")} name='c3_home_address_town' id='c3_home_address_town' onChange={(e) => doFormOnChange(e)} />
															</div>
														</div>

														<div style={{ display: 'flex', margin: 4 }}>
															<div className='row50'>
																<label htmlFor='c3_home_address_county'>County:</label>
															</div>
															<div className='row50'>
																<input data-form-id={ifid} disabled={isInstructed} type='text' value={getFormValueWithId(ifid, "c3_home_address_county")} name='c3_home_address_county' id='c3_home_address_county' onChange={(e) => doFormOnChange(e)} />
															</div>
														</div>

														<div style={{ display: 'flex', margin: 4 }}>
															<div className='row50'>
																<label htmlFor='c3_home_address_postcode'>Postcode:</label>
															</div>
															<div className='row50'>
																<input data-form-id={ifid} data-valid-type="*" className={getFormValidWithId(ifid, "c3_home_address_postcode") ? undefined : 'error'} disabled={isInstructed} type='text' value={getFormValueWithId(ifid, "c3_home_address_postcode")} name='c3_home_address_postcode' id='c3_home_address_postcode' onChange={(e) => doFormOnChange(e)} />
															</div>
														</div>

														<div style={{ display: 'flex', margin: 4 }}>
															<div className='row50'></div>
															<div className='row50'>
																<div className='buttonGreen' style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', overflow: 'hidden', flex: '1 1 0px' }} onClick={() => getPostcodeAddresses(ifid, 'c3_home_address')}>
																	<div style={{ display: 'flex' }}>
																		<FontAwesomeIcon style={{ fontSize: 18, marginRight: 8 }} icon={faMagnifyingGlassLocation} />
																		<div style={{ whiteSpace: 'nowrap', textOverflow: 'ellipsis', overflow: 'hidden' }}>Find Postcode</div>
																	</div>
																	{forms.isGettingAddress['c3_home_address'] &&
																		<FontAwesomeIcon className='fa-spin' style={{ fontSize: 18, marginRight: 8 }} icon={faSync} />
																	}
																</div>
															</div>
														</div>

														{getAddressListWithId('c3_home_address').length > 0 &&
															<div style={{ display: 'flex', margin: 4 }}>
																<div className='row50'>Select Address:</div>
																<div className='row50'>
																	<select data-form-id={ifid} value={getFormValueWithId(ifid, "c3_home_address")} name='c3_home_address' onChange={(e) => selectAddress(e)}>
																		<option value=''>Please Select...</option>
																		{getAddressListWithId('c3_home_address').map((item: Forms.postcodeAddressState, index: number) => {
																			return (
																				<option key={index} value={index}> {item.premise}, {item.street}, {item.posttown}, {item.county}.</option>
																			)
																		})}
																	</select>
																</div>
															</div>
														}
													</div>
												}
											</div>
										}

										{getFormValueWithId(ifid, "c3_comp_or_ind") === "1" &&
											<div>
												<div style={{ fontFamily: 'OpenSans-Bold', margin: 4 }}>Company Details</div>

												<div style={{ display: 'flex', margin: 4 }}>
													<div className='row50'>
														<label htmlFor='c3_company_name'>Company Full Name:</label>
													</div>
													<div className='row50'>
														<input data-form-id={ifid} data-valid-type="*" className={getFormValidWithId(ifid, "c3_company_name") ? undefined : 'error'} disabled={isInstructed} type='text' value={getFormValueWithId(ifid, "c3_company_name")} name='c3_company_name' id='c3_company_name' onChange={(e) => doFormOnChange(e)} />
													</div>
												</div>

												<div style={{ display: 'flex', margin: 4 }}>
													<div className='row50'>
														<label htmlFor='c3_company_number'>Company Number:</label>
													</div>
													<div className='row50'>
														<input data-form-id={ifid} data-valid-type="*" className={getFormValidWithId(ifid, "c3_company_number") ? undefined : 'error'} disabled={isInstructed} type='text' value={getFormValueWithId(ifid, "c3_company_number")} name='c3_company_number' id='c3_company_number' onChange={(e) => doFormOnChange(e)} />
													</div>
												</div>

												<div style={{ display: 'flex', margin: 4 }}>
													<div className='row50'>
														<label htmlFor='c3_contact1_name'>Contact Name:</label>
													</div>
													<div className='row50'>
														<input data-form-id={ifid} data-valid-type="*" className={getFormValidWithId(ifid, "c3_contact1_name") ? undefined : 'error'} disabled={isInstructed} type='text' value={getFormValueWithId(ifid, "c3_contact1_name")} name='c3_contact1_name' id='c3_contact1_name' onChange={(e) => doFormOnChange(e)} />
													</div>
												</div>

												<div style={{ display: 'flex', margin: 4 }}>
													<div className='row50'>
														<label htmlFor='c3_contact1_email'>Contact Email Address:</label>
													</div>
													<div className='row50'>
														<input data-form-id={ifid} data-valid-type="email" className={getFormValidWithId(ifid, "c3_contact1_email") ? undefined : 'error'} disabled={isInstructed} type='text' value={getFormValueWithId(ifid, "c3_contact1_email")} name='c3_contact1_email' id='c3_contact1_email' onChange={(e) => doFormOnChange(e)} />
													</div>
												</div>

												<div style={{ display: 'flex', margin: 4 }}>
													<div className='row50'>
														<label htmlFor='c3_contact1_mobile'>Contact Mobile Phone No:</label>
													</div>
													<div className='row50'>
														<input data-form-id={ifid} data-valid-type="*" className={getFormValidWithId(ifid, "c3_contact1_mobile") ? undefined : 'error'} disabled={isInstructed} type='text' value={getFormValueWithId(ifid, "c3_contact1_mobile")} name='c3_contact1_mobile' id='c3_contact1_mobile' onChange={(e) => doFormOnChange(e)} />
													</div>
												</div>

												<div style={{ fontFamily: 'OpenSans-Bold', margin: 4 }}>Registered Office Address</div>

												<div style={{ display: 'flex', margin: 4 }}>
													<div className='row50'>
														<label htmlFor='c3_company_property'>Property No./Name:</label>
													</div>
													<div className='row50'>
														<input data-form-id={ifid} data-valid-type="*" className={getFormValidWithId(ifid, "c3_company_property") ? undefined : 'error'} disabled={isInstructed} type='text' value={getFormValueWithId(ifid, "c3_company_property")} name='c3_company_property' id='c3_company_property' onChange={(e) => doFormOnChange(e)} />
													</div>
												</div>

												<div style={{ display: 'flex', margin: 4 }}>
													<div className='row50'>
														<label htmlFor='c3_company_street'>Street:</label>
													</div>
													<div className='row50'>
														<input data-form-id={ifid} data-valid-type="*" className={getFormValidWithId(ifid, "c3_company_street") ? undefined : 'error'} disabled={isInstructed} type='text' value={getFormValueWithId(ifid, "c3_company_street")} name='c3_company_street' id='c3_company_street' onChange={(e) => doFormOnChange(e)} />
													</div>
												</div>

												<div style={{ display: 'flex', margin: 4 }}>
													<div className='row50'>
														<label htmlFor='c3_company_town'>Town:</label>
													</div>
													<div className='row50'>
														<input data-form-id={ifid} data-valid-type="*" className={getFormValidWithId(ifid, "c3_company_town") ? undefined : 'error'} disabled={isInstructed} type='text' value={getFormValueWithId(ifid, "c3_company_town")} name='c3_company_town' id='c3_company_town' onChange={(e) => doFormOnChange(e)} />
													</div>
												</div>

												<div style={{ display: 'flex', margin: 4 }}>
													<div className='row50'>
														<label htmlFor='c3_company_county'>County:</label>
													</div>
													<div className='row50'>
														<input data-form-id={ifid} disabled={isInstructed} type='text' value={getFormValueWithId(ifid, "c3_company_county")} name='c3_company_county' id='c3_company_county' onChange={(e) => doFormOnChange(e)} />
													</div>
												</div>

												<div style={{ display: 'flex', margin: 4 }}>
													<div className='row50'>
														<label htmlFor='c3_company_postcode'>Postcode:</label>
													</div>
													<div className='row50'>
														<input data-form-id={ifid} data-valid-type="*" className={getFormValidWithId(ifid, "c3_company_postcode") ? undefined : 'error'} disabled={isInstructed} type='text' value={getFormValueWithId(ifid, "c3_company_postcode")} name='c3_company_postcode' id='c3_company_postcode' onChange={(e) => doFormOnChange(e)} />
													</div>
												</div>

												<div style={{ display: 'flex', margin: 4 }}>
													<div className='row50'></div>
													<div className='row50'>
														<div className='buttonGreen' style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', overflow: 'hidden', flex: '1 1 0px' }} onClick={() => getPostcodeAddresses(ifid, 'c3_company')}>
															<div style={{ display: 'flex' }}>
																<FontAwesomeIcon style={{ fontSize: 18, marginRight: 8 }} icon={faMagnifyingGlassLocation} />
																<div style={{ whiteSpace: 'nowrap', textOverflow: 'ellipsis', overflow: 'hidden' }}>Find Postcode</div>
															</div>
															{forms.isGettingAddress['c3_company'] &&
																<FontAwesomeIcon className='fa-spin' style={{ fontSize: 18, marginRight: 8 }} icon={faSync} />
															}
														</div>
													</div>
												</div>

												{getAddressListWithId('c3_company').length > 0 &&
													<div style={{ display: 'flex', margin: 4 }}>
														<div className='row50'>Select Address:</div>
														<div className='row50'>
															<select data-form-id={ifid} value={getFormValueWithId(ifid, "c3_company")} name='c3_company' onChange={(e) => selectAddress(e)}>
																<option value=''>Please Select...</option>
																{getAddressListWithId('c3_company').map((item: Forms.postcodeAddressState, index: number) => {
																	return (
																		<option key={index} value={index}> {item.premise}, {item.street}, {item.posttown}, {item.county}.</option>
																	)
																})}
															</select>
														</div>
													</div>
												}

												<div style={{ display: 'flex', margin: 4 }}>
													<div className='row50'>Is this company Registered in the UK?</div>
													<div className='row50' style={{ display: 'flex', alignItems: 'center' }}>
														<div className='row33' style={{ display: 'flex', alignItems: 'center' }}>
															<div style={{ padding: 8 }}>
																<input data-form-id={ifid} className={getFormValidWithId(ifid, "c3_uk_registered") ? undefined : 'error'} disabled={isInstructed} type='radio' value='1' id="c3_uk_registered_yes" name='c3_uk_registered' checked={getFormValueWithId(ifid, "c3_uk_registered") === '1'} onChange={(e) => doFormOnChange(e)} />
															</div>
															<div className='flexGrow1'>
																<label htmlFor="c3_uk_registered_yes">Yes</label>
															</div>
														</div>
														<div className='row33' style={{ display: 'flex', alignItems: 'center' }}>
															<div style={{ padding: 8 }}>
																<input data-form-id={ifid} className={getFormValidWithId(ifid, "c3_uk_registered") ? undefined : 'error'} disabled={isInstructed} type='radio' value='2' id="c3_uk_registered_no" name='c3_uk_registered' checked={getFormValueWithId(ifid, "c3_uk_registered") === '2'} onChange={(e) => doFormOnChange(e)} />
															</div>
															<div className='flexGrow1'>
																<label htmlFor="c3_uk_registered_no">No</label>
															</div>
														</div>
													</div>
												</div>
											</div>
										}
									</div>
								}

								{parseInt(getFormValueWithId(qfid, "quote_nclients")) > 3 &&
									<div>
										<div className="main_rule"></div>
										<div style={{ fontFamily: 'OpenSans-Bold', margin: 4 }}>Remortgager 4 Details</div>

										<div style={{ display: 'flex', margin: 4 }}>
											<div className='row50'>Is this a Company or an Individual?</div>
											<div className='row50'>
												<select data-form-id={ifid} data-valid-type="*" className={getFormValidWithId(ifid, "c4_comp_or_ind") ? undefined : 'error'} disabled={isInstructed} value={getFormValueWithId(ifid, "c4_comp_or_ind")} name='c4_comp_or_ind' onChange={(e) => doFormOnChange(e)}>
													<option value=''>Please Select...</option>
													<option value='0'>Individual</option>
													<option value='1'>Company</option>
												</select>
											</div>
										</div>

										{getFormValueWithId(ifid, "c4_comp_or_ind") === "0" &&
											<div>
												<div style={{ fontFamily: 'OpenSans-Bold', margin: 4 }}>Client 4 Details</div>

												<div style={{ display: 'flex', margin: 4 }}>
													<div className='row50'>Title:</div>
													<div className='row50'>
														<select data-form-id={ifid} data-valid-type="*" className={getFormValidWithId(ifid, "c4_title") ? undefined : 'error'} disabled={isInstructed} value={getFormValueWithId(ifid, "c4_title")} name='c4_title' onChange={(e) => doFormOnChange(e)}>
															<option value=''>Please Select...</option>
															<option value='Miss'>Miss</option>
															<option value='Ms'>Ms</option>
															<option value='Mrs'>Mrs</option>
															<option value='Mr'>Mr</option>
															<option value='Dr'>Dr</option>
															<option value='Other'>Other</option>
														</select>
													</div>
												</div>

												{getFormValueWithId(ifid, "c4_title") === "Other" &&
													<div style={{ display: 'flex', margin: 4 }}>
														<div className='row50'>
															<label htmlFor='c4_title_specify'>Please Specify:</label>
														</div>
														<div className='row50'>
															<input data-form-id={ifid} data-valid-type="*" className={getFormValidWithId(ifid, "c4_title_specify") ? undefined : 'error'} disabled={isInstructed} type='text' value={getFormValueWithId(ifid, "c4_title_specify")} name='c4_title_specify' id='c4_title_specify' onChange={(e) => doFormOnChange(e)} />
														</div>
													</div>
												}

												<div style={{ display: 'flex', margin: 4 }}>
													<div className='row50'>
														<label htmlFor='c4_firstname'>First Name:</label>
													</div>
													<div className='row50'>
														<input data-form-id={ifid} data-valid-type="*" className={getFormValidWithId(ifid, "c4_firstname") ? undefined : 'error'} disabled={isInstructed} type='text' value={getFormValueWithId(ifid, "c4_firstname")} name='c4_firstname' id='c4_firstname' onChange={(e) => doFormOnChange(e)} />
													</div>
												</div>

												<div style={{ display: 'flex', margin: 4 }}>
													<div className='row50'>
														<label htmlFor='c4_middlenames'>Middle Names:</label>
													</div>
													<div className='row50'>
														<input data-form-id={ifid} disabled={isInstructed} type='text' value={getFormValueWithId(ifid, "c4_middlenames")} name='c4_middlenames' id='c4_middlenames' onChange={(e) => doFormOnChange(e)} />
													</div>
												</div>

												<div style={{ display: 'flex', margin: 4 }}>
													<div className='row50'>
														<label htmlFor='c4_surname'>Surname:</label>
													</div>
													<div className='row50'>
														<input data-form-id={ifid} data-valid-type="*" className={getFormValidWithId(ifid, "c4_surname") ? undefined : 'error'} disabled={isInstructed} type='text' value={getFormValueWithId(ifid, "c4_surname")} name='c4_surname' id='c4_surname' onChange={(e) => doFormOnChange(e)} />
													</div>
												</div>

												<div style={{ display: 'flex', margin: 4 }}>
													<div className='row50'>
														<label htmlFor='c4_email'>Email Address:</label>
													</div>
													<div className='row50' style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', gap: '3px'}}>
														<input data-form-id={ifid} data-valid-type="email" data-valid-message='Please enter a valid Email address' data-valid-unique='["c1_email","c2_email","c3_email"]' data-unique-message='Email address must be unique to this Client' className={getFormValidWithId(ifid, "c4_email") ? undefined : 'error'} disabled={isInstructed} type='text' value={getFormValueWithId(ifid, "c4_email")} name='c4_email' id='c4_email' onChange={(e) => doFormOnChange(e)} />
														{!getFormValidWithId(ifid, 'c4_email') &&
															<div style={{ color: 'red', fontSize: '14px' }}>{getFormMessageWithId(ifid, 'c4_email')}</div>
														}
													</div>
												</div>

												<div style={{ display: 'flex', margin: 4 }}>
													<div className='row50'>
														<label htmlFor='c4_main_number'>Home Phone No:</label>
													</div>
													<div className='row50'>
														<input data-form-id={ifid} disabled={isInstructed} type='text' value={getFormValueWithId(ifid, "c4_main_number")} name='c4_main_number' id='c4_main_number' onChange={(e) => doFormOnChange(e)} />
													</div>
												</div>

												<div style={{ display: 'flex', margin: 4 }}>
													<div className='row50'>
														<label htmlFor='c4_mobile_number'>Mobile Phone No:</label>
													</div>
													<div className='row50'>
														<input data-form-id={ifid} data-valid-type="*" data-valid-unique='["c1_mobile_number","c2_mobile_number","c3_mobile_number"]' data-unique-message='Mobile number must be unique to this Client' className={getFormValidWithId(ifid, "c4_mobile_number") ? undefined : 'error'} disabled={isInstructed} type='text' value={getFormValueWithId(ifid, "c4_mobile_number")} name='c4_mobile_number' id='c4_mobile_number' onChange={(e) => doFormOnChange(e)} />
														{!getFormValidWithId(ifid, 'c4_mobile_number') &&
															<div style={{ color: 'red',fontSize: '14px' }}>{getFormMessageWithId(ifid, 'c4_mobile_number')}</div>
														}
													</div>
												</div>

												<div style={{ display: 'flex', margin: 4 }}>
													<div className='row50'>
														<div style={{ display: 'flex', flexDirection: 'column' }}>
															<div>Is Client 4 a UK Resident?</div>
															<div style={{ fontSize: 12 }}>For more information please click <a href="https://www.gov.uk/government/publications/rdr3-statutory-residence-test-srt" target="_blank">here</a></div>
														</div>
													</div>
													<div className='row50' style={{ display: 'flex', alignItems: 'center' }}>
														<div className='row33' style={{ display: 'flex', alignItems: 'center' }}>
															<div style={{ padding: 8 }}>
																<input data-form-id={ifid} className={getFormValidWithId(ifid, "c4_uk_resident") ? undefined : 'error'} disabled={isInstructed} type='radio' value='1' id="c4_uk_resident_yes" name='c4_uk_resident' checked={getFormValueWithId(ifid, "c4_uk_resident") === '1'} onChange={(e) => doFormOnChange(e)} />
															</div>
															<div className='flexGrow1'>
																<label htmlFor="c4_uk_resident_yes">Yes</label>
															</div>
														</div>
														<div className='row33' style={{ display: 'flex', alignItems: 'center' }}>
															<div style={{ padding: 8 }}>
																<input data-form-id={ifid} className={getFormValidWithId(ifid, "c4_uk_resident") ? undefined : 'error'} disabled={isInstructed} type='radio' value='2' id="c4_uk_resident_no" name='c4_uk_resident' checked={getFormValueWithId(ifid, "c4_uk_resident") === '2'} onChange={(e) => doFormOnChange(e)} />
															</div>
															<div className='flexGrow1'>
																<label htmlFor="c4_uk_resident_no">No</label>
															</div>
														</div>
													</div>
												</div>

												<div style={{ display: 'flex', margin: 4 }}>
													<div className='row50' style={{ fontFamily: 'OpenSans-Bold' }}>Client 4 Home Address</div>
													<div className='row50'>
														<div style={{ display: 'flex', alignItems: 'center' }}>
															<div style={{ padding: 8 }}>
																<input data-form-id={ifid} disabled={isInstructed} type="checkbox" checked={getFormValueWithId(ifid, "c4_ind_addr_pop") === 'true'} name="c4_ind_addr_pop" id="c4_ind_addr_pop" onChange={(e) => doFormOnChange(e)} />
															</div>
															<div>
																<label htmlFor='c4_ind_addr_pop'>Use Property Address</label>
															</div>
														</div>
													</div>
												</div>

												{(getFormValueWithId(ifid, "c4_ind_addr_pop") === 'false' || getFormValueWithId(ifid, "c4_ind_addr_pop") === '') &&
													<div>
														<div style={{ display: 'flex', margin: 4 }}>
															<div className='row50'>
																<label htmlFor='c4_home_address_house'>House No./Name:</label>
															</div>
															<div className='row50'>
																<input data-form-id={ifid} data-valid-type="*" className={getFormValidWithId(ifid, "c4_home_address_house") ? undefined : 'error'} disabled={isInstructed} type='text' value={getFormValueWithId(ifid, "c4_home_address_house")} name='c4_home_address_house' id='c4_home_address_house' onChange={(e) => doFormOnChange(e)} />
															</div>
														</div>

														<div style={{ display: 'flex', margin: 4 }}>
															<div className='row50'>
																<label htmlFor='c4_home_address_street'>Street:</label>
															</div>
															<div className='row50'>
																<input data-form-id={ifid} data-valid-type="*" className={getFormValidWithId(ifid, "c4_home_address_street") ? undefined : 'error'} disabled={isInstructed} type='text' value={getFormValueWithId(ifid, "c4_home_address_street")} name='c4_home_address_street' id='c4_home_address_street' onChange={(e) => doFormOnChange(e)} />
															</div>
														</div>

														<div style={{ display: 'flex', margin: 4 }}>
															<div className='row50'>
																<label htmlFor='c4_home_address_town'>Town:</label>
															</div>
															<div className='row50'>
																<input data-form-id={ifid} data-valid-type="*" className={getFormValidWithId(ifid, "c4_home_address_town") ? undefined : 'error'} disabled={isInstructed} type='text' value={getFormValueWithId(ifid, "c4_home_address_town")} name='c4_home_address_town' id='c4_home_address_town' onChange={(e) => doFormOnChange(e)} />
															</div>
														</div>

														<div style={{ display: 'flex', margin: 4 }}>
															<div className='row50'>
																<label htmlFor='c4_home_address_county'>County:</label>
															</div>
															<div className='row50'>
																<input data-form-id={ifid} disabled={isInstructed} type='text' value={getFormValueWithId(ifid, "c4_home_address_county")} name='c4_home_address_county' id='c4_home_address_county' onChange={(e) => doFormOnChange(e)} />
															</div>
														</div>

														<div style={{ display: 'flex', margin: 4 }}>
															<div className='row50'>
																<label htmlFor='c4_home_address_postcode'>Postcode:</label>
															</div>
															<div className='row50'>
																<input data-form-id={ifid} data-valid-type="*" className={getFormValidWithId(ifid, "c4_home_address_postcode") ? undefined : 'error'} disabled={isInstructed} type='text' value={getFormValueWithId(ifid, "c4_home_address_postcode")} name='c4_home_address_postcode' id='c4_home_address_postcode' onChange={(e) => doFormOnChange(e)} />
															</div>
														</div>

														<div style={{ display: 'flex', margin: 4 }}>
															<div className='row50'></div>
															<div className='row50'>
																<div className='buttonGreen' style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', overflow: 'hidden', flex: '1 1 0px' }} onClick={() => getPostcodeAddresses(ifid, 'c4_home_address')}>
																	<div style={{ display: 'flex' }}>
																		<FontAwesomeIcon style={{ fontSize: 18, marginRight: 8 }} icon={faMagnifyingGlassLocation} />
																		<div style={{ whiteSpace: 'nowrap', textOverflow: 'ellipsis', overflow: 'hidden' }}>Find Postcode</div>
																	</div>
																	{forms.isGettingAddress['c4_home_address'] &&
																		<FontAwesomeIcon className='fa-spin' style={{ fontSize: 18, marginRight: 8 }} icon={faSync} />
																	}
																</div>
															</div>
														</div>

														{getAddressListWithId('c4_home_address').length > 0 &&
															<div style={{ display: 'flex', margin: 4 }}>
																<div className='row50'>Select Address:</div>
																<div className='row50'>
																	<select data-form-id={ifid} value={getFormValueWithId(ifid, "c4_home_address")} name='c4_home_address' onChange={(e) => selectAddress(e)}>
																		<option value=''>Please Select...</option>
																		{getAddressListWithId('c4_home_address').map((item: Forms.postcodeAddressState, index: number) => {
																			return (
																				<option key={index} value={index}> {item.premise}, {item.street}, {item.posttown}, {item.county}.</option>
																			)
																		})}
																	</select>
																</div>
															</div>
														}
													</div>
												}
											</div>
										}

										{getFormValueWithId(ifid, "c4_comp_or_ind") === "1" &&
											<div>
												<div style={{ fontFamily: 'OpenSans-Bold', margin: 4 }}>Company Details</div>

												<div style={{ display: 'flex', margin: 4 }}>
													<div className='row50'>
														<label htmlFor='c4_company_name'>Company Full Name:</label>
													</div>
													<div className='row50'>
														<input data-form-id={ifid} data-valid-type="*" className={getFormValidWithId(ifid, "c4_company_name") ? undefined : 'error'} disabled={isInstructed} type='text' value={getFormValueWithId(ifid, "c4_company_name")} name='c4_company_name' id='c4_company_name' onChange={(e) => doFormOnChange(e)} />
													</div>
												</div>

												<div style={{ display: 'flex', margin: 4 }}>
													<div className='row50'>
														<label htmlFor='c4_company_number'>Company Number:</label>
													</div>
													<div className='row50'>
														<input data-form-id={ifid} data-valid-type="*" className={getFormValidWithId(ifid, "c4_company_number") ? undefined : 'error'} disabled={isInstructed} type='text' value={getFormValueWithId(ifid, "c4_company_number")} name='c4_company_number' id='c4_company_number' onChange={(e) => doFormOnChange(e)} />
													</div>
												</div>

												<div style={{ display: 'flex', margin: 4 }}>
													<div className='row50'>
														<label htmlFor='c4_contact1_name'>Contact Name:</label>
													</div>
													<div className='row50'>
														<input data-form-id={ifid} data-valid-type="*" className={getFormValidWithId(ifid, "c4_contact1_name") ? undefined : 'error'} disabled={isInstructed} type='text' value={getFormValueWithId(ifid, "c4_contact1_name")} name='c4_contact1_name' id='c4_contact1_name' onChange={(e) => doFormOnChange(e)} />
													</div>
												</div>

												<div style={{ display: 'flex', margin: 4 }}>
													<div className='row50'>
														<label htmlFor='c4_contact1_email'>Contact Email Address:</label>
													</div>
													<div className='row50'>
														<input data-form-id={ifid} data-valid-type="email" className={getFormValidWithId(ifid, "c4_contact1_email") ? undefined : 'error'} disabled={isInstructed} type='text' value={getFormValueWithId(ifid, "c4_contact1_email")} name='c4_contact1_email' id='c4_contact1_email' onChange={(e) => doFormOnChange(e)} />
													</div>
												</div>

												<div style={{ display: 'flex', margin: 4 }}>
													<div className='row50'>
														<label htmlFor='c4_contact1_mobile'>Contact Mobile Phone No:</label>
													</div>
													<div className='row50'>
														<input data-form-id={ifid} data-valid-type="*" className={getFormValidWithId(ifid, "c4_contact1_mobile") ? undefined : 'error'} disabled={isInstructed} type='text' value={getFormValueWithId(ifid, "c4_contact1_mobile")} name='c4_contact1_mobile' id='c4_contact1_mobile' onChange={(e) => doFormOnChange(e)} />
													</div>
												</div>

												<div style={{ fontFamily: 'OpenSans-Bold', margin: 4 }}>Registered Office Address</div>

												<div style={{ display: 'flex', margin: 4 }}>
													<div className='row50'>
														<label htmlFor='c4_company_property'>Property No./Name:</label>
													</div>
													<div className='row50'>
														<input data-form-id={ifid} data-valid-type="*" className={getFormValidWithId(ifid, "c4_company_property") ? undefined : 'error'} disabled={isInstructed} type='text' value={getFormValueWithId(ifid, "c4_company_property")} name='c4_company_property' id='c4_company_property' onChange={(e) => doFormOnChange(e)} />
													</div>
												</div>

												<div style={{ display: 'flex', margin: 4 }}>
													<div className='row50'>
														<label htmlFor='c4_company_street'>Street:</label>
													</div>
													<div className='row50'>
														<input data-form-id={ifid} data-valid-type="*" className={getFormValidWithId(ifid, "c4_company_street") ? undefined : 'error'} disabled={isInstructed} type='text' value={getFormValueWithId(ifid, "c4_company_street")} name='c4_company_street' id='c4_company_street' onChange={(e) => doFormOnChange(e)} />
													</div>
												</div>

												<div style={{ display: 'flex', margin: 4 }}>
													<div className='row50'>
														<label htmlFor='c4_company_town'>Town:</label>
													</div>
													<div className='row50'>
														<input data-form-id={ifid} data-valid-type="*" className={getFormValidWithId(ifid, "c4_company_town") ? undefined : 'error'} disabled={isInstructed} type='text' value={getFormValueWithId(ifid, "c4_company_town")} name='c4_company_town' id='c4_company_town' onChange={(e) => doFormOnChange(e)} />
													</div>
												</div>

												<div style={{ display: 'flex', margin: 4 }}>
													<div className='row50'>
														<label htmlFor='c4_company_county'>County:</label>
													</div>
													<div className='row50'>
														<input data-form-id={ifid} disabled={isInstructed} type='text' value={getFormValueWithId(ifid, "c4_company_county")} name='c4_company_county' id='c4_company_county' onChange={(e) => doFormOnChange(e)} />
													</div>
												</div>

												<div style={{ display: 'flex', margin: 4 }}>
													<div className='row50'>
														<label htmlFor='c4_company_postcode'>Postcode:</label>
													</div>
													<div className='row50'>
														<input data-form-id={ifid} data-valid-type="*" className={getFormValidWithId(ifid, "c4_company_postcode") ? undefined : 'error'} disabled={isInstructed} type='text' value={getFormValueWithId(ifid, "c4_company_postcode")} name='c4_company_postcode' id='c4_company_postcode' onChange={(e) => doFormOnChange(e)} />
													</div>
												</div>

												<div style={{ display: 'flex', margin: 4 }}>
													<div className='row50'></div>
													<div className='row50'>
														<div className='buttonGreen' style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', overflow: 'hidden', flex: '1 1 0px' }} onClick={() => getPostcodeAddresses(ifid, 'c4_company')}>
															<div style={{ display: 'flex' }}>
																<FontAwesomeIcon style={{ fontSize: 18, marginRight: 8 }} icon={faMagnifyingGlassLocation} />
																<div style={{ whiteSpace: 'nowrap', textOverflow: 'ellipsis', overflow: 'hidden' }}>Find Postcode</div>
															</div>
															{forms.isGettingAddress['c4_company'] &&
																<FontAwesomeIcon className='fa-spin' style={{ fontSize: 18, marginRight: 8 }} icon={faSync} />
															}
														</div>
													</div>
												</div>

												{getAddressListWithId('c4_company').length > 0 &&
													<div style={{ display: 'flex', margin: 4 }}>
														<div className='row50'>Select Address:</div>
														<div className='row50'>
															<select data-form-id={ifid} value={getFormValueWithId(ifid, "c4_company")} name='c4_company' onChange={(e) => selectAddress(e)}>
																<option value=''>Please Select...</option>
																{getAddressListWithId('c4_company').map((item: Forms.postcodeAddressState, index: number) => {
																	return (
																		<option key={index} value={index}> {item.premise}, {item.street}, {item.posttown}, {item.county}.</option>
																	)
																})}
															</select>
														</div>
													</div>
												}

												<div style={{ display: 'flex', margin: 4 }}>
													<div className='row50'>Is this company Registered in the UK?</div>
													<div className='row50' style={{ display: 'flex', alignItems: 'center' }}>
														<div className='row33' style={{ display: 'flex', alignItems: 'center' }}>
															<div style={{ padding: 8 }}>
																<input data-form-id={ifid} className={getFormValidWithId(ifid, "c4_uk_registered") ? undefined : 'error'} disabled={isInstructed} type='radio' value='1' id="c4_uk_registered_yes" name='c4_uk_registered' checked={getFormValueWithId(ifid, "c4_uk_registered") === '1'} onChange={(e) => doFormOnChange(e)} />
															</div>
															<div className='flexGrow1'>
																<label htmlFor="c4_uk_registered_yes">Yes</label>
															</div>
														</div>
														<div className='row33' style={{ display: 'flex', alignItems: 'center' }}>
															<div style={{ padding: 8 }}>
																<input data-form-id={ifid} className={getFormValidWithId(ifid, "c4_uk_registered") ? undefined : 'error'} disabled={isInstructed} type='radio' value='2' id="c4_uk_registered_no" name='c4_uk_registered' checked={getFormValueWithId(ifid, "c4_uk_registered") === '2'} onChange={(e) => doFormOnChange(e)} />
															</div>
															<div className='flexGrow1'>
																<label htmlFor="c4_uk_registered_no">No</label>
															</div>
														</div>
													</div>
												</div>
											</div>
										}
									</div>
								}
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
}

export default QuoteRemortgage;